import {
  MimeType as GrafferMimeType,
  TaxRateLiterals,
} from "@graffer-inc/cloud-gov-core";
import { GraphQLClient, RequestOptions } from "graphql-request";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Amount: { input: number; output: number };
  Any: { input: any; output: any };
  CustomTag: { input: any; output: any };
  GrafferMimeType: { input: GrafferMimeType; output: GrafferMimeType };
  JSONDocument: { input: any; output: any };
  JpkiGender: { input: any; output: any };
  Map: { input: any; output: any };
  QualifiedInvoiceDetailBusinessIssuerRegistrationNumber: {
    input: any;
    output: any;
  };
  TaxRate: { input: TaxRateLiterals; output: TaxRateLiterals };
  Time: { input: any; output: any };
};

export type AdjustmentRequiredDetail = {
  __typename?: "AdjustmentRequiredDetail";
  deficiency?: Maybe<Scalars["Amount"]["output"]>;
  exceeding?: Maybe<Scalars["Amount"]["output"]>;
};

export type ApplicantSchemaKeys = {
  __typename?: "ApplicantSchemaKeys";
  applicantAddress: SchemaKey;
  applicantBirthDate: SchemaKey;
  applicantContactPersonal: SchemaKey;
  applicantCorporateNumber: SchemaKey;
  applicantCorporateSearch: SchemaKey;
  applicantEmail: SchemaKey;
  applicantName: SchemaKey;
  applicantNameKana: SchemaKey;
  applicantPhoneNumber: SchemaKey;
  applicantPostalCode: SchemaKey;
  applicantRepresentativeName: SchemaKey;
  applicantSection: SchemaKey;
  applicantTradeName: SchemaKey;
  applicantTradeNameKana: SchemaKey;
  applicantType: SchemaKey;
};

export type Application = {
  __typename?: "Application";
  applicantContent?: Maybe<ApplicationContent>;
  createdAt: Scalars["Time"]["output"];
  createdAtUnixSecond: Scalars["Int"]["output"];
  files: Array<AttachFileWithUrl>;
  id: Scalars["ID"]["output"];
  issueFiles: Array<IssueFileWithUrl>;
  jsonDocument: Scalars["Any"]["output"];
  modifiedAt?: Maybe<Scalars["Time"]["output"]>;
  myNumbers?: Maybe<Array<MyNumberWithId>>;
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  paymentsV2?: Maybe<Array<PaymentSnapshot>>;
  procedureId: Scalars["ID"]["output"];
  procedureVersion: Scalars["Int"]["output"];
  signature?: Maybe<Signature>;
  status: Status;
  tenantProcessResult?: Maybe<Scalars["Any"]["output"]>;
  updatedAt: Scalars["Time"]["output"];
  updatedAtUnixSecond: Scalars["Int"]["output"];
  userIdExists: Scalars["Boolean"]["output"];
  version: Scalars["Int"]["output"];
};

export type ApplicationContent = {
  __typename?: "ApplicationContent";
  files: Array<AttachFileWithUrl>;
  jsonDocument: Scalars["Any"]["output"];
  modifiedAt?: Maybe<Scalars["Time"]["output"]>;
  myNumbers?: Maybe<Array<MyNumberWithId>>;
};

export type ApplicationDetailData = {
  __typename?: "ApplicationDetailData";
  application: Application;
  procedure: Procedure;
};

export type ApplicationEvent = {
  __typename?: "ApplicationEvent";
  applicationId: Scalars["ID"]["output"];
  createdAt: Scalars["Time"]["output"];
  createdBy: UserMetaInfoWithName;
  data: Scalars["Any"]["output"];
  eventType: ApplicationEventType;
  id: Scalars["ID"]["output"];
  orgId: Scalars["ID"]["output"];
  transactionID: Scalars["ID"]["output"];
};

export type ApplicationEventType =
  | "ContentModified"
  | "Created"
  | "InternalCommentAdded"
  | "IssueFilesAdded"
  | "IssueFilesCancelled"
  | "IssueFilesFirstDownloaded"
  | "MessageAdded"
  | "PaymentAdded"
  | "PaymentDeficiencyAdjusted"
  | "PaymentExceedingAdjusted"
  | "PaymentExpired"
  | "PaymentPaid"
  | "PaymentPayeasyRequested"
  | "PaymentRefunded"
  | "PaymentWithdrawn"
  | "RemovalTaskCanceled"
  | "RemovalTaskScheduled"
  | "StatusReverted"
  | "StatusUpdated"
  | "TenantProcessResultUpdated";

export type ApplicationEventsAndMessages = {
  __typename?: "ApplicationEventsAndMessages";
  events: Array<ApplicationEvent>;
  messages: Array<Message>;
};

export type ApplicationHistory = {
  __typename?: "ApplicationHistory";
  applicationId: Scalars["ID"]["output"];
  createdAt: Scalars["Time"]["output"];
  createdBy: Scalars["String"]["output"];
  files: Array<AttachFileWithUrl>;
  id: Scalars["ID"]["output"];
  internalCommentId?: Maybe<Scalars["ID"]["output"]>;
  jsonDocument: Scalars["Any"]["output"];
  modificationType: ModificationType;
  modifiedAt: Scalars["Time"]["output"];
  modifiedBy: UserMetaInfoWithName;
  myNumbers?: Maybe<Array<MyNumberWithId>>;
  orgId: Scalars["ID"]["output"];
  signature?: Maybe<Signature>;
};

export type ApplicationHistoryAndComment = {
  __typename?: "ApplicationHistoryAndComment";
  applicationHistory: ApplicationHistory;
  internalComment?: Maybe<InternalComment>;
};

export type ApplicationTaskAndUser = {
  __typename?: "ApplicationTaskAndUser";
  createdAt: Scalars["Time"]["output"];
  id: Scalars["ID"]["output"];
  orgId: Scalars["ID"]["output"];
  taskDetails: Array<ApplicationTaskDetail>;
  taskType: TaskType;
  updatedAt: Scalars["Time"]["output"];
  user: ApplicationTaskOrgUser;
};

export type ApplicationTaskDetail = {
  __typename?: "ApplicationTaskDetail";
  applicationId: Scalars["ID"]["output"];
  errCode?: Maybe<Scalars["String"]["output"]>;
  taskStatus: TaskStatus;
};

export type ApplicationTaskOrgUser = {
  __typename?: "ApplicationTaskOrgUser";
  name: Scalars["String"]["output"];
};

export type ApplicationWithApplicantSchemaKeys = {
  __typename?: "ApplicationWithApplicantSchemaKeys";
  applicantSchemaKeys: ApplicantSchemaKeys;
  application: Application;
};

export type ApplicationWithProcedure = {
  __typename?: "ApplicationWithProcedure";
  application: Application;
  procedure: Procedure;
};

export type ApplicationsWithApplicantSchemaKeys = {
  __typename?: "ApplicationsWithApplicantSchemaKeys";
  applications: Array<ApplicationWithApplicantSchemaKeys>;
  totalCount: Scalars["Int"]["output"];
};

export type ApplicationsWithApplicationSchemaKeysSort = "asc" | "desc";

export type ArchiveProcedureResult = {
  __typename?: "ArchiveProcedureResult";
  ok: Scalars["Boolean"]["output"];
};

export type AssignedApplicationsProceduresResponse = {
  __typename?: "AssignedApplicationsProceduresResponse";
  procedures: Array<BaseProcedure>;
};

export type AttachFileWithUrl = {
  __typename?: "AttachFileWithURL";
  name: Scalars["String"]["output"];
  refKey?: Maybe<Scalars["String"]["output"]>;
  size: Scalars["Int"]["output"];
  tags?: Maybe<Array<Scalars["String"]["output"]>>;
  type: Scalars["GrafferMimeType"]["output"];
  url: Scalars["String"]["output"];
};

export type AuthLevelCorp = "NONE";

export type AuthLevelIndividual = "MY_NUMBER_CARD_SIGNATURE" | "NONE";

export type BaseProcedure = {
  __typename?: "BaseProcedure";
  descriptionMarkdown: Scalars["String"]["output"];
  detailURL?: Maybe<Scalars["String"]["output"]>;
  groupIds: Array<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  isExcludeFromSearch: Scalars["Boolean"]["output"];
  isGrafferManaged: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  publishSetting: PublishSetting;
  publishStatus: PublishStatus;
  summary?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Time"]["output"];
};

export type CertCheckResult = {
  __typename?: "CertCheckResult";
  asof: Scalars["String"]["output"];
  isPending: Scalars["Boolean"]["output"];
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  issuerDn: Scalars["String"]["output"];
  notAfter: Scalars["String"]["output"];
  notBefore: Scalars["String"]["output"];
  signatureId: Scalars["String"]["output"];
  surrogate: Scalars["String"]["output"];
  uid?: Maybe<Scalars["Int"]["output"]>;
  verifyTicket: Scalars["String"]["output"];
};

export type CertificateEnum = "JPKI_SIG_CERT" | "MOJ_CERT";

export type CreateKintoneExportSettingInput = {
  description: Scalars["String"]["input"];
  disabled: Scalars["Boolean"]["input"];
  elementFieldMappings: Array<UpsertKintoneExportElementFieldMappingInput>;
  formResourceId: Scalars["ID"]["input"];
  kintoneAPIToken: Scalars["String"]["input"];
  kintoneAppId: Scalars["String"]["input"];
  kintoneSubdomain: Scalars["String"]["input"];
  metadataFieldMapping: UpsertKintoneExportMetadataFieldMappingInput;
  name: Scalars["String"]["input"];
  tenantId: Scalars["String"]["input"];
};

export type CreateSurveyAnswerDraftInput = {
  answer: Scalars["Map"]["input"];
  files?: InputMaybe<Array<PreUploadFileInput>>;
  surveyID: Scalars["ID"]["input"];
};

export type CurrentCustomPaths = {
  __typename?: "CurrentCustomPaths";
  currentCustomPath?: Maybe<CustomPath>;
  nextCustomPath?: Maybe<CustomPath>;
};

export type CustomPath = {
  __typename?: "CustomPath";
  customPath: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  procedureId: Scalars["ID"]["output"];
  startUnixtime: Scalars["Int"]["output"];
};

export type CustomerDlConfig = {
  __typename?: "CustomerDlConfig";
  pdfDownloadConfig?: Maybe<PdfDownloadConfig>;
};

export type DeleteSurveyAnswerDraftInput = {
  id: Scalars["ID"]["input"];
  surveyID: Scalars["ID"]["input"];
};

export type DeleteSurveyAnswerDraftResult = {
  __typename?: "DeleteSurveyAnswerDraftResult";
  ok: Scalars["Boolean"]["output"];
};

export type Detail = {
  __typename?: "Detail";
  acceptAnyFile: Scalars["Boolean"]["output"];
  applicantSchemaKeys: ApplicantSchemaKeys;
  paymentSetting?: Maybe<PaymentSettingV2>;
  requireAuthLevel: RequireAuthLevel;
  template: Template;
};

export type DomainError = {
  __typename?: "DomainError";
  code: DomainErrorCode;
  message: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
};

export type DomainErrorCode = "bad_request" | "not_found";

export type EmptyResult = {
  __typename?: "EmptyResult";
  msg: EmptyResultMsg;
};

export type EmptyResultMsg = "OK";

export type FixedInvoice = {
  __typename?: "FixedInvoice";
  items: Array<FixedInvoiceItem>;
};

export type FixedInvoiceItem = {
  __typename?: "FixedInvoiceItem";
  amount: Scalars["Amount"]["output"];
  description: Scalars["String"]["output"];
  fixedAt: Scalars["Time"]["output"];
  operationType: PaymentOperationType;
  taxRate: Scalars["TaxRate"]["output"];
  type: InvoiceItemType;
};

export type GetSurveyAnswerDraftInput = {
  id: Scalars["ID"]["input"];
  surveyID: Scalars["ID"]["input"];
};

export type InternalComment = {
  __typename?: "InternalComment";
  applicationId: Scalars["ID"]["output"];
  content: Scalars["String"]["output"];
  createdAt: Scalars["Time"]["output"];
  createdBy?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  operationType: OperationType;
};

export type InternalCommentAndUser = {
  __typename?: "InternalCommentAndUser";
  applicationId: Scalars["ID"]["output"];
  content: Scalars["String"]["output"];
  createdAt: Scalars["Time"]["output"];
  createdBy?: Maybe<InternalCommentOrgUser>;
  id: Scalars["ID"]["output"];
  operationType: OperationType;
};

export type InternalCommentOrgUser = {
  __typename?: "InternalCommentOrgUser";
  name: Scalars["String"]["output"];
};

export type Invoice = {
  __typename?: "Invoice";
  items: Array<InvoiceItem>;
};

export type InvoiceItem = {
  __typename?: "InvoiceItem";
  amount: Scalars["Amount"]["output"];
  description: Scalars["String"]["output"];
  taxRate: Scalars["TaxRate"]["output"];
  type: InvoiceItemType;
};

export type InvoiceItemSetting = {
  __typename?: "InvoiceItemSetting";
  description: Scalars["String"]["output"];
  formulaId: Scalars["String"]["output"];
  taxRate: Scalars["TaxRate"]["output"];
};

export type InvoiceItemType =
  | "Default"
  | "Deficiency"
  | "DeficiencyAdjuster"
  | "Exceeding"
  | "ExceedingAdjuster";

export type InvoiceItemWithRefundableAmount = {
  __typename?: "InvoiceItemWithRefundableAmount";
  amount: Scalars["Amount"]["output"];
  description: Scalars["String"]["output"];
  refundableAmount: Scalars["Amount"]["output"];
  taxRate: Scalars["TaxRate"]["output"];
  type: InvoiceItemType;
};

export type InvoiceWithRefundableAmount = {
  __typename?: "InvoiceWithRefundableAmount";
  items: Array<InvoiceItemWithRefundableAmount>;
};

export type IsNotFound = {
  __typename?: "IsNotFound";
  error: DomainError;
};

export type IsOutdatedAppVersion = {
  __typename?: "IsOutdatedAppVersion";
  error: DomainError;
};

export type IssueFileWithUrl = {
  __typename?: "IssueFileWithURL";
  isDeleted: Scalars["Boolean"]["output"];
  isDownloaded: Scalars["Boolean"]["output"];
  isLgpkiSigned?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  type: Scalars["GrafferMimeType"]["output"];
  url: Scalars["String"]["output"];
};

export type IssueQualifiedInvoiceInput = {
  applicationId: Scalars["ID"]["input"];
  buyerName?: InputMaybe<Scalars["String"]["input"]>;
  defaultTaxAmount?: InputMaybe<Scalars["Amount"]["input"]>;
  qualifiedInvoiceIssueRequestId: Scalars["ID"]["input"];
  reducedTaxAmount?: InputMaybe<Scalars["Amount"]["input"]>;
  transactionDate: QualifiedInvoiceTransactionDateInput;
};

export type JpkiSubjectAltName = {
  __typename?: "JPKISubjectAltName";
  address: Scalars["String"]["output"];
  commonName: Scalars["String"]["output"];
  dateOfBirth: Scalars["String"]["output"];
  gender: Scalars["JpkiGender"]["output"];
  substituteCharacterOfAddress: Scalars["String"]["output"];
  substituteCharacterOfCommonName: Scalars["String"]["output"];
};

export type KintoneExportAplStatusUpdateLog = {
  __typename?: "KintoneExportAplStatusUpdateLog";
  after: Status;
  before: Status;
};

export type KintoneExportElementFieldMapping = {
  __typename?: "KintoneExportElementFieldMapping";
  formElementId: Scalars["String"]["output"];
  kintoneFieldCode: Scalars["String"]["output"];
};

export type KintoneExportErrorDetail = {
  __typename?: "KintoneExportErrorDetail";
  errors: Array<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  reportId: Scalars["ID"]["output"];
  settingId: Scalars["ID"]["output"];
  smartApplySubmissionId: Scalars["ID"]["output"];
};

export type KintoneExportErrorDetailConnection = {
  __typename?: "KintoneExportErrorDetailConnection";
  edges: Array<KintoneExportErrorDetailEdge>;
  totalCount: Scalars["Int"]["output"];
};

export type KintoneExportErrorDetailEdge = {
  __typename?: "KintoneExportErrorDetailEdge";
  node: KintoneExportErrorDetail;
};

export type KintoneExportMetadataFieldMapping = {
  __typename?: "KintoneExportMetadataFieldMapping";
  procedureNameFieldCode?: Maybe<Scalars["String"]["output"]>;
  submissionIdFieldCode: Scalars["String"]["output"];
  submissionStatusFieldCode?: Maybe<Scalars["String"]["output"]>;
  submittedAtFieldCode: Scalars["String"]["output"];
};

export type KintoneExportReport = {
  __typename?: "KintoneExportReport";
  createdAtUnixSecond: Scalars["Int"]["output"];
  details: Array<KintoneExportReportDetail>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  exportSettingId: Scalars["ID"]["output"];
  grafferTraceId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  startedAtUnixSecond: Scalars["Int"]["output"];
  submissionFilter: KintoneExportReportSubmissionFilter;
  tenantId: Scalars["String"]["output"];
};

export type KintoneExportReportConnection = {
  __typename?: "KintoneExportReportConnection";
  edges: Array<KintoneExportReportEdge>;
  totalCount: Scalars["Int"]["output"];
};

export type KintoneExportReportDetail = {
  __typename?: "KintoneExportReportDetail";
  aplStatusUpdate?: Maybe<KintoneExportAplStatusUpdateLog>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  existingRecord?: Maybe<KintoneExportReportDetailExistingRecord>;
  kintoneRecordId?: Maybe<Scalars["String"]["output"]>;
  kintoneRecordRevision?: Maybe<Scalars["String"]["output"]>;
  skippedByAplStatus?: Maybe<Status>;
  smartApplySubmissionId: Scalars["ID"]["output"];
};

export type KintoneExportReportDetailExistingRecord = {
  __typename?: "KintoneExportReportDetailExistingRecord";
  exportedRecordId: Scalars["ID"]["output"];
  kintoneRecordId: Scalars["String"]["output"];
};

export type KintoneExportReportEdge = {
  __typename?: "KintoneExportReportEdge";
  node: KintoneExportReport;
};

export type KintoneExportReportFilter = {
  kintoneExportSettingId?: InputMaybe<Scalars["ID"]["input"]>;
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KintoneExportReportSubmissionFilter = {
  __typename?: "KintoneExportReportSubmissionFilter";
  formResourceId: Scalars["ID"]["output"];
  fromUnixSecond: Scalars["Int"]["output"];
  tenantId: Scalars["String"]["output"];
  toUnixSecond: Scalars["Int"]["output"];
};

export type KintoneExportRequest = {
  __typename?: "KintoneExportRequest";
  createdAtUnixSecond: Scalars["Int"]["output"];
  createdReportId: Scalars["ID"]["output"];
  errorDetail: Scalars["String"]["output"];
  exportSettingId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  specifiedSubmissionIds: Array<Scalars["ID"]["output"]>;
  status: KintoneExportRequestStatus;
  tenantId: Scalars["String"]["output"];
  term?: Maybe<KintoneExportRequestTerm>;
  updatedAtUnixSecond: Scalars["Int"]["output"];
};

export type KintoneExportRequestStatus =
  | "failed"
  | "pending"
  | "running"
  | "succeeded";

export type KintoneExportRequestTerm = {
  __typename?: "KintoneExportRequestTerm";
  fromUnixMilli: Scalars["Int"]["output"];
  toUnixMilli: Scalars["Int"]["output"];
};

export type KintoneExportResourcePage = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
};

export type KintoneExportSetting = {
  __typename?: "KintoneExportSetting";
  createdAtUnixSecond: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  disabled: Scalars["Boolean"]["output"];
  elementFieldMappings: Array<KintoneExportElementFieldMapping>;
  formResourceId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  kintoneAppId: Scalars["String"]["output"];
  kintoneSubdomain: Scalars["String"]["output"];
  metadataFieldMapping: KintoneExportMetadataFieldMapping;
  name: Scalars["String"]["output"];
  tenantId: Scalars["String"]["output"];
  updatedAtUnixSecond: Scalars["Int"]["output"];
};

export type KintoneExportSettingConnection = {
  __typename?: "KintoneExportSettingConnection";
  edges: Array<KintoneExportSettingEdge>;
  totalCount: Scalars["Int"]["output"];
};

export type KintoneExportSettingEdge = {
  __typename?: "KintoneExportSettingEdge";
  node: KintoneExportSetting;
};

export type KintoneExportSettingFilter = {
  disabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  formResourceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  groupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KintoneExportedRecord = {
  __typename?: "KintoneExportedRecord";
  createdAtUnixSecond: Scalars["Int"]["output"];
  exportSettingId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  kintoneAppId: Scalars["String"]["output"];
  kintoneRecordId: Scalars["String"]["output"];
  kintoneRecordRevision: Scalars["String"]["output"];
  smartApplySubmissionId: Scalars["ID"]["output"];
  tenantId: Scalars["String"]["output"];
};

export type KintoneExportedRecordConnection = {
  __typename?: "KintoneExportedRecordConnection";
  edges: Array<KintoneExportedRecordEdge>;
  totalCount: Scalars["Int"]["output"];
};

export type KintoneExportedRecordEdge = {
  __typename?: "KintoneExportedRecordEdge";
  node: KintoneExportedRecord;
};

export type KintoneExportedRecordFilter = {
  kintoneExportSettingId?: InputMaybe<Scalars["ID"]["input"]>;
  smartApplySubmissionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KintoneFieldsResponse = {
  __typename?: "KintoneFieldsResponse";
  properties: Scalars["Map"]["output"];
  revision: Scalars["String"]["output"];
};

export type KintoneRecordMetadata = {
  __typename?: "KintoneRecordMetadata";
  recordId: Scalars["String"]["output"];
  submissionId: Scalars["ID"]["output"];
};

export type LiveProcedureResponse = {
  __typename?: "LiveProcedureResponse";
  /** @deprecated Field no longer supported */
  domainError?: Maybe<DomainError>;
  legalTermUrl: Scalars["String"]["output"];
  procedure: Procedure;
};

export type Message = {
  __typename?: "Message";
  applicationId: Scalars["ID"]["output"];
  content: Scalars["String"]["output"];
  createdAt: Scalars["Time"]["output"];
  createdBy: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  operationType: OperationType;
};

export type ModificationType =
  | "CONFIRMED_TO_APPLICANT"
  | "INITIAL_CONTENT"
  | "ORG_USER_DECISION";

export type Mutation = {
  __typename?: "Mutation";
  adjustPaymentExceedingOrDeficiency: Scalars["Boolean"]["output"];
  archiveProcedure: ArchiveProcedureResult;
  createKintoneExportSetting: KintoneExportSetting;
  createQualifiedInvoiceIssueRequest: Scalars["Boolean"]["output"];
  createSurveyAnswerDraft: SurveyAnswerDraft;
  deleteKintoneExportedRecord: EmptyResult;
  deleteSurveyAnswerDraft: DeleteSurveyAnswerDraftResult;
  issueProcedureAccessSession: ProcedureAccessSessionResult;
  issueQualifiedInvoice: Scalars["Boolean"]["output"];
  noop: Scalars["String"]["output"];
  preparePostPaymentLinkPurchaseRequest: Scalars["Boolean"]["output"];
  reRequestQualifiedInvoiceIssueRequest: Scalars["Boolean"]["output"];
  removeSurveyAnswers: RemoveSurveyAnswersResult;
  requestKintoneExport: KintoneExportRequest;
  requestPayeasy: Scalars["Boolean"]["output"];
  revertStatus: RevertStatusMutationResult;
  revokeQualifiedInvoice: Scalars["Boolean"]["output"];
  unarchiveProcedure: UnarchiveProcedureResult;
  updateKintoneExportSetting: KintoneExportSetting;
  updateSurveyAnswerDraft: SurveyAnswerDraft;
  updateTenantProcessResult: Scalars["Boolean"]["output"];
  verifyProcedurePasscode: PasscodeVerificationResult;
  withdrawQualifiedInvoiceIssueRequest: Scalars["Boolean"]["output"];
};

export type MutationAdjustPaymentExceedingOrDeficiencyArgs = {
  applicationId: Scalars["ID"]["input"];
  paymentIndex: Scalars["Int"]["input"];
  version: Scalars["Int"]["input"];
};

export type MutationArchiveProcedureArgs = {
  previousUpdatedAtUnixTime: Scalars["Float"]["input"];
  procedureId: Scalars["String"]["input"];
};

export type MutationCreateKintoneExportSettingArgs = {
  input: CreateKintoneExportSettingInput;
};

export type MutationCreateQualifiedInvoiceIssueRequestArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type MutationCreateSurveyAnswerDraftArgs = {
  input?: InputMaybe<CreateSurveyAnswerDraftInput>;
};

export type MutationDeleteKintoneExportedRecordArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteSurveyAnswerDraftArgs = {
  input?: InputMaybe<DeleteSurveyAnswerDraftInput>;
};

export type MutationIssueProcedureAccessSessionArgs = {
  procedureId: Scalars["String"]["input"];
};

export type MutationIssueQualifiedInvoiceArgs = {
  input: IssueQualifiedInvoiceInput;
};

export type MutationPreparePostPaymentLinkPurchaseRequestArgs = {
  input: PreparePostPaymentLinkPurchaseRequestInput;
};

export type MutationReRequestQualifiedInvoiceIssueRequestArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type MutationRemoveSurveyAnswersArgs = {
  surveyId: Scalars["ID"]["input"];
};

export type MutationRequestKintoneExportArgs = {
  input: RequestKintoneExportInput;
};

export type MutationRequestPayeasyArgs = {
  input: RequestPayeasy;
};

export type MutationRevertStatusArgs = {
  applicationId: Scalars["ID"]["input"];
  revertStatusCommand: RevertStatusCommand;
};

export type MutationRevokeQualifiedInvoiceArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type MutationUnarchiveProcedureArgs = {
  previousUpdatedAtUnixTime: Scalars["Float"]["input"];
  procedureId: Scalars["String"]["input"];
};

export type MutationUpdateKintoneExportSettingArgs = {
  input: UpdateKintoneExportSettingInput;
};

export type MutationUpdateSurveyAnswerDraftArgs = {
  input?: InputMaybe<UpdateSurveyAnswerDraftInput>;
};

export type MutationUpdateTenantProcessResultArgs = {
  applicationId: Scalars["ID"]["input"];
  document: Scalars["Map"]["input"];
};

export type MutationVerifyProcedurePasscodeArgs = {
  passcode: Scalars["String"]["input"];
  procedureId: Scalars["String"]["input"];
};

export type MutationWithdrawQualifiedInvoiceIssueRequestArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type MyNumberWithId = {
  __typename?: "MyNumberWithID";
  last4Digit?: Maybe<Scalars["String"]["output"]>;
  myNumberId: Scalars["String"]["output"];
  refKey: Scalars["String"]["output"];
};

export type OperationType = "comment" | "message" | "modification" | "refund";

export type PdfDownloadConfig = {
  __typename?: "PDFDownloadConfig";
  description?: Maybe<Scalars["String"]["output"]>;
  fileName: Scalars["String"]["output"];
};

export type PdfOutputSetting = {
  __typename?: "PDFOutputSetting";
  metaInfoFormSchema?: Maybe<Scalars["Any"]["output"]>;
  pdfOutputBaseFile?: Maybe<Scalars["Any"]["output"]>;
  pdfOutputBaseFileName: Scalars["String"]["output"];
  pdfOutputBaseFileURL: Scalars["String"]["output"];
};

export type Page = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  currentPage: Scalars["Int"]["output"];
  totalPage: Scalars["Int"]["output"];
};

export type PagedApplications = {
  __typename?: "PagedApplications";
  applications: Array<Application>;
  procedure: Procedure;
  totalCount: Scalars["Int"]["output"];
};

export type PasscodeVerificationResult = {
  __typename?: "PasscodeVerificationResult";
  ok: Scalars["Boolean"]["output"];
};

export type PayeasyDetail = {
  __typename?: "PayeasyDetail";
  billDate: Scalars["String"]["output"];
  confirmationNum: Scalars["String"]["output"];
  customerNum: Scalars["String"]["output"];
  expiredAt?: Maybe<Scalars["Int"]["output"]>;
  invoiceNo: Scalars["String"]["output"];
  isExpiredWithNoPayment: Scalars["Boolean"]["output"];
  isPaid: Scalars["Boolean"]["output"];
  paidAmount: Scalars["Amount"]["output"];
  skNo: Scalars["String"]["output"];
};

export type PayeasyPayload = {
  __typename?: "PayeasyPayload";
  mail: Scalars["String"]["output"];
  tel: Scalars["String"]["output"];
};

export type PayeasyPayloadResult = IsNotFound | PayeasyPayload;

export type PayeasyRequestDetail = {
  mail: Scalars["String"]["input"];
  tel: Scalars["String"]["input"];
};

export type PaymentDetail = {
  __typename?: "PaymentDetail";
  adjustmentRequiredDetail?: Maybe<AdjustmentRequiredDetail>;
  amount: Scalars["Amount"]["output"];
  amountDetail?: Maybe<Scalars["Any"]["output"]>;
  amountRefunded: Scalars["Amount"]["output"];
  invoice: InvoiceWithRefundableAmount;
  isRefundablePaymentMethod: Scalars["Boolean"]["output"];
  payeasyDetail?: Maybe<Array<PayeasyDetail>>;
  paymentId: Scalars["ID"]["output"];
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  taxAmountDetail?: Maybe<Scalars["Any"]["output"]>;
};

export type PaymentLinkPurchaseRequestArguments = {
  amount: Scalars["Amount"]["input"];
  cancelURL: Scalars["String"]["input"];
  customerCode: Scalars["String"]["input"];
  details: Array<PaymentLinkPurchaseRequestArgumentsDetail>;
  errorURL: Scalars["String"]["input"];
  itemId: Scalars["String"]["input"];
  itemName: Scalars["String"]["input"];
  orderId: Scalars["String"]["input"];
  pageconURL: Scalars["String"]["input"];
  payMethod: Scalars["String"]["input"];
  requestDate: Scalars["String"]["input"];
  spsHashCode: Scalars["String"]["input"];
  successURL: Scalars["String"]["input"];
  tax: Scalars["Amount"]["input"];
};

export type PaymentLinkPurchaseRequestArgumentsDetail = {
  amount: Scalars["Amount"]["input"];
  itemCount: Scalars["Int"]["input"];
  itemId: Scalars["String"]["input"];
  itemName: Scalars["String"]["input"];
  rowNumber: Scalars["Int"]["input"];
  tax: Scalars["Amount"]["input"];
};

export type PaymentLinkPurchaseRequestFormArguments = {
  __typename?: "PaymentLinkPurchaseRequestFormArguments";
  amount: Scalars["Amount"]["output"];
  cancelURL: Scalars["String"]["output"];
  customerCode: Scalars["String"]["output"];
  details: Array<PaymentLinkPurchaseRequestFormArgumentsDetail>;
  errorURL: Scalars["String"]["output"];
  itemId: Scalars["String"]["output"];
  itemName: Scalars["String"]["output"];
  limitSecond: Scalars["String"]["output"];
  orderId: Scalars["String"]["output"];
  pageconURL: Scalars["String"]["output"];
  payMethod: Scalars["String"]["output"];
  payType: Scalars["String"]["output"];
  paymentLinkPOSTActionURL: Scalars["String"]["output"];
  requestDate: Scalars["String"]["output"];
  sbpsMerchantId: Scalars["String"]["output"];
  sbpsServiceId: Scalars["String"]["output"];
  serviceType: Scalars["String"]["output"];
  spsCustomerCode: Scalars["String"]["output"];
  spsHashCode: Scalars["String"]["output"];
  spsPaymentNumber: Scalars["String"]["output"];
  successURL: Scalars["String"]["output"];
  tax: Scalars["Amount"]["output"];
  trackingId: Scalars["String"]["output"];
};

export type PaymentLinkPurchaseRequestFormArgumentsDetail = {
  __typename?: "PaymentLinkPurchaseRequestFormArgumentsDetail";
  amount: Scalars["Amount"]["output"];
  itemCount: Scalars["Int"]["output"];
  itemId: Scalars["String"]["output"];
  itemName: Scalars["String"]["output"];
  rowNumber: Scalars["Int"]["output"];
  tax: Scalars["Amount"]["output"];
};

export type PaymentMethod = "credit_card" | "payeasy";

export type PaymentOperation = {
  __typename?: "PaymentOperation";
  amount: Scalars["Amount"]["output"];
  applicationId: Scalars["ID"]["output"];
  createdAt: Scalars["Time"]["output"];
  items: Array<InvoiceItem>;
  paymentId: Scalars["ID"]["output"];
  paymentTransactionType: PaymentOperationType;
};

export type PaymentOperationType =
  | "ADJUST_CHARGE"
  | "ADJUST_REFUND"
  | "CHARGE"
  | "PARTIAL_REFUND"
  | "REFUND";

export type PaymentSettingV2 = {
  __typename?: "PaymentSettingV2";
  items: Array<InvoiceItemSetting>;
};

export type PaymentSnapshot = {
  __typename?: "PaymentSnapshot";
  acceptedPaymentMethods: Array<PaymentMethod>;
  amount: Scalars["Amount"]["output"];
  amountCharged: Scalars["Amount"]["output"];
  amountDetail: Scalars["Any"]["output"];
  amountRefunded: Scalars["Amount"]["output"];
  invoice: Invoice;
  isCancelled: Scalars["Boolean"]["output"];
  paymentId?: Maybe<Scalars["ID"]["output"]>;
  status: PaymentStatus;
  taxAmount: Scalars["Amount"]["output"];
  taxAmountDetail: Scalars["Any"]["output"];
};

export type PaymentStatus =
  | "cancelled"
  | "paid"
  | "partial_refunded"
  | "refunded"
  | "requested";

export type PaymentSummary = {
  __typename?: "PaymentSummary";
  adjustmentRequiredDetail?: Maybe<AdjustmentRequiredDetail>;
  amount: Scalars["Amount"]["output"];
  amountDetail?: Maybe<Scalars["Any"]["output"]>;
  amountRefunded: Scalars["Amount"]["output"];
  invoice: FixedInvoice;
  operations: Array<PaymentOperation>;
  taxAmountDetail?: Maybe<Scalars["Any"]["output"]>;
};

export type Permission =
  | "applications_count"
  | "applications_issueFileAdd"
  | "applications_paymentAdjustment"
  | "applications_read"
  | "applications_statusRevert"
  | "applications_taskRead"
  | "applications_tenantProcessResultUpdate"
  | "kintoneExport_errorDetail_read"
  | "kintoneExport_exportRequest_create"
  | "kintoneExport_exportRequest_read"
  | "kintoneExport_exportedRecord_delete"
  | "kintoneExport_exportedRecord_read"
  | "kintoneExport_report_read"
  | "kintoneExport_setting_create"
  | "kintoneExport_setting_read"
  | "kintoneExport_setting_update"
  | "orgSamlSettings_create"
  | "orgSamlSettings_read"
  | "orgSamlSettings_update"
  | "organizations_create"
  | "organizations_update"
  | "procedures_countPublishing"
  | "procedures_read"
  | "procedures_update"
  | "qualifiedInvoiceIssueRequest_list"
  | "qualifiedInvoiceIssueRequest_withdraw"
  | "qualifiedInvoice_issue"
  | "qualifiedInvoice_revoke"
  | "surveyAnswers_count"
  | "surveyAnswers_delete"
  | "surveys_countPublishing"
  | "users_read";

export type PreUploadFile = {
  __typename?: "PreUploadFile";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  refKey: Scalars["String"]["output"];
  size: Scalars["Int"]["output"];
  type: Scalars["GrafferMimeType"]["output"];
};

export type PreUploadFileInput = {
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  refKey: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  type: Scalars["GrafferMimeType"]["input"];
};

export type PreparePostPaymentLinkPurchaseRequestInput = {
  applicationId: Scalars["ID"]["input"];
  paymentIndex: Scalars["Int"]["input"];
  purchaseRequestArguments: PaymentLinkPurchaseRequestArguments;
};

export type Procedure = {
  __typename?: "Procedure";
  customTag?: Maybe<Scalars["CustomTag"]["output"]>;
  customerDlConfig?: Maybe<CustomerDlConfig>;
  descriptionMarkdown: Scalars["String"]["output"];
  detailURL?: Maybe<Scalars["String"]["output"]>;
  draft: Detail;
  groupIds: Array<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  isExcludeFromSearch: Scalars["Boolean"]["output"];
  isGrafferManaged: Scalars["Boolean"]["output"];
  isLinkTopPage: Scalars["Boolean"]["output"];
  isSkipArrivalMail: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  publishSetting: PublishSetting;
  publishStatus: PublishStatus;
  published?: Maybe<PublishedDetail>;
  summary?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Time"]["output"];
  version: Scalars["Int"]["output"];
};

export type ProcedureAccessSessionResult = {
  __typename?: "ProcedureAccessSessionResult";
  sessionId?: Maybe<Scalars["String"]["output"]>;
};

export type ProcedureAplsReachedQuota = {
  __typename?: "ProcedureAplsReachedQuota";
  error: DomainError;
};

export type ProceduresWithCustomPathResult = {
  __typename?: "ProceduresWithCustomPathResult";
  procHasReservedCustomPath?: Maybe<Procedure>;
  procUsingCustomPath?: Maybe<Procedure>;
};

export type PublishSetting = {
  __typename?: "PublishSetting";
  endAcceptAt?: Maybe<Scalars["Time"]["output"]>;
  isPausingAccept: Scalars["Boolean"]["output"];
  publishAt?: Maybe<Scalars["Time"]["output"]>;
  startAcceptAt?: Maybe<Scalars["Time"]["output"]>;
  unPublishAt?: Maybe<Scalars["Time"]["output"]>;
};

export type PublishStatus =
  | "ACCEPTING"
  | "BEFORE_ACCEPTING"
  | "BEFORE_PUBLISH"
  | "DRAFT"
  | "FINISHED_ACCEPTING"
  | "PAUSING_ACCEPT"
  | "UNPUBLISHED";

export type PublishedDetail = {
  __typename?: "PublishedDetail";
  acceptAnyFile: Scalars["Boolean"]["output"];
  applicantSchemaKeys: ApplicantSchemaKeys;
  paymentSetting?: Maybe<PaymentSettingV2>;
  requireAuthLevel: RequireAuthLevel;
  template: Template;
};

export type QualifiedInvoice = {
  __typename?: "QualifiedInvoice";
  applicationId: Scalars["ID"]["output"];
  createdAt: Scalars["Time"]["output"];
  detail: QualifiedInvoiceDetail;
  id: Scalars["ID"]["output"];
  qualifiedInvoiceIssueRequestId: Scalars["ID"]["output"];
};

export type QualifiedInvoiceDetail = {
  __typename?: "QualifiedInvoiceDetail";
  buyerName?: Maybe<Scalars["String"]["output"]>;
  payment: QualifiedInvoiceDetailPayment;
  qualifiedInvoiceBusinessIssuer: QualifiedInvoiceDetailBusinessIssuer;
  transactionDate: QualifiedInvoiceTransactionDate;
};

export type QualifiedInvoiceDetailBusinessIssuer = {
  __typename?: "QualifiedInvoiceDetailBusinessIssuer";
  name: Scalars["String"]["output"];
  registrationNumber: Scalars["QualifiedInvoiceDetailBusinessIssuerRegistrationNumber"]["output"];
};

export type QualifiedInvoiceDetailPayment = {
  __typename?: "QualifiedInvoiceDetailPayment";
  amount: Scalars["Amount"]["output"];
  amountDetail: Scalars["Any"]["output"];
  items: Array<QualifiedInvoiceDetailPaymentItem>;
  taxAmountDetail: Scalars["Any"]["output"];
};

export type QualifiedInvoiceDetailPaymentItem = {
  __typename?: "QualifiedInvoiceDetailPaymentItem";
  amount: Scalars["Amount"]["output"];
  description: Scalars["String"]["output"];
  taxRate: Scalars["TaxRate"]["output"];
};

export type QualifiedInvoiceIssueControlStatus = {
  __typename?: "QualifiedInvoiceIssueControlStatus";
  hasTaxablePayment: Scalars["Boolean"]["output"];
  isIssuableApplicationStatus: Scalars["Boolean"]["output"];
  isIssuableProcedure: Scalars["Boolean"]["output"];
  isPaymentCompleted: Scalars["Boolean"]["output"];
};

export type QualifiedInvoiceIssueRequest = {
  __typename?: "QualifiedInvoiceIssueRequest";
  applicationId: Scalars["ID"]["output"];
  availableIssuedQualifiedInvoice?: Maybe<QualifiedInvoiceIssueRequestIssuedQualifiedInvoice>;
  id: Scalars["ID"]["output"];
  orgId: Scalars["ID"]["output"];
  revokedQualifiedInvoices: Array<QualifiedInvoiceIssueRequestIssuedQualifiedInvoice>;
  withdrewAt?: Maybe<Scalars["Time"]["output"]>;
};

export type QualifiedInvoiceIssueRequestIssuedQualifiedInvoice = {
  __typename?: "QualifiedInvoiceIssueRequestIssuedQualifiedInvoice";
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Time"]["output"];
  revokedAt?: Maybe<Scalars["Time"]["output"]>;
};

export type QualifiedInvoiceTransactionDate = {
  __typename?: "QualifiedInvoiceTransactionDate";
  day: Scalars["Int"]["output"];
  month: Scalars["Int"]["output"];
  year: Scalars["Int"]["output"];
};

export type QualifiedInvoiceTransactionDateInput = {
  day: Scalars["Int"]["input"];
  month: Scalars["Int"]["input"];
  year: Scalars["Int"]["input"];
};

export type Query = {
  __typename?: "Query";
  application: Application;
  applicationCountByOrgId: Scalars["Int"]["output"];
  applicationDetailData: ApplicationDetailData;
  applicationEventsAndMessages: ApplicationEventsAndMessages;
  applicationHistories: Array<ApplicationHistoryAndComment>;
  applicationTaskAndUser: ApplicationTaskAndUser;
  applicationWithProcedure: ApplicationWithProcedure;
  applicationsByProcedure: PagedApplications;
  applicationsWithApplicantSchemaKeys: ApplicationsWithApplicantSchemaKeys;
  assignedApplications: ApplicationsWithApplicantSchemaKeys;
  assignedApplicationsProcedures: AssignedApplicationsProceduresResponse;
  currentCustomPaths: CurrentCustomPaths;
  healthcheck: Scalars["String"]["output"];
  internalCommentsAndUsers: Array<InternalCommentAndUser>;
  kintoneExportErrorDetails: KintoneExportErrorDetailConnection;
  kintoneExportReport: KintoneExportReport;
  kintoneExportReportsV2: KintoneExportReportConnection;
  kintoneExportRequest: KintoneExportRequest;
  kintoneExportSetting: KintoneExportSetting;
  kintoneExportSettingsV2: KintoneExportSettingConnection;
  kintoneExportedRecordsV2: KintoneExportedRecordConnection;
  kintoneFields: KintoneFieldsResponse;
  kintoneRecordMetadataByExportedRecordId: KintoneRecordMetadata;
  latestQualifiedInvoice?: Maybe<QualifiedInvoice>;
  liveProcedure: LiveProcedureResponse;
  messages: Array<Message>;
  payeasyPayload: PayeasyPayloadResult;
  paymentDetailByPayments: Array<PaymentDetail>;
  paymentSummary: PaymentSummary;
  postPaymentLinkPurchaseRequestFormArguments: PaymentLinkPurchaseRequestFormArguments;
  proceduresWithCustomPath?: Maybe<ProceduresWithCustomPathResult>;
  publishingProcedureCount: Scalars["Int"]["output"];
  publishingSurveyCount: Scalars["Int"]["output"];
  qualifiedInvoice?: Maybe<QualifiedInvoice>;
  qualifiedInvoiceDetailPayment?: Maybe<QualifiedInvoiceDetailPayment>;
  qualifiedInvoiceIssueControlStatus: QualifiedInvoiceIssueControlStatus;
  qualifiedInvoiceIssueRequest?: Maybe<QualifiedInvoiceIssueRequest>;
  removedApplicationWithProcedure: RemovedApplicationWithProcedure;
  removedApplications: RemovedApplicationsResult;
  surveyAnswerCountByOrgId: Scalars["Int"]["output"];
  surveyAnswerDraft: SurveyAnswerDraft;
  unhandledQualifiedInvoiceIssueRequests: Array<UnhandledQualifiedInvoiceIssueRequestResponse>;
  verifyProcedureAccessSession: EmptyResult;
};

export type QueryApplicationArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryApplicationCountByOrgIdArgs = {
  orgId: Scalars["ID"]["input"];
};

export type QueryApplicationDetailDataArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type QueryApplicationEventsAndMessagesArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryApplicationHistoriesArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryApplicationTaskAndUserArgs = {
  taskId: Scalars["String"]["input"];
};

export type QueryApplicationWithProcedureArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryApplicationsByProcedureArgs = {
  from?: InputMaybe<Scalars["String"]["input"]>;
  limit: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  procedureId: Scalars["String"]["input"];
  status?: InputMaybe<Array<Status>>;
  to?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryApplicationsWithApplicantSchemaKeysArgs = {
  from?: InputMaybe<Scalars["String"]["input"]>;
  limit: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  sort: ApplicationsWithApplicationSchemaKeysSort;
  status?: InputMaybe<Array<Status>>;
  to?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAssignedApplicationsArgs = {
  from?: InputMaybe<Scalars["String"]["input"]>;
  limit: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  procedureId?: InputMaybe<Scalars["String"]["input"]>;
  sort: ApplicationsWithApplicationSchemaKeysSort;
  status?: InputMaybe<Array<Status>>;
  to?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAssignedApplicationsProceduresArgs = {
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCurrentCustomPathsArgs = {
  orgId: Scalars["String"]["input"];
  procedureId: Scalars["String"]["input"];
};

export type QueryInternalCommentsAndUsersArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryKintoneExportErrorDetailsArgs = {
  reportId: Scalars["ID"]["input"];
};

export type QueryKintoneExportReportArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryKintoneExportReportsV2Args = {
  filter: KintoneExportReportFilter;
  page: KintoneExportResourcePage;
};

export type QueryKintoneExportRequestArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryKintoneExportSettingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryKintoneExportSettingsV2Args = {
  filter: KintoneExportSettingFilter;
  page: KintoneExportResourcePage;
};

export type QueryKintoneExportedRecordsV2Args = {
  filter: KintoneExportedRecordFilter;
  page: KintoneExportResourcePage;
};

export type QueryKintoneFieldsArgs = {
  kintoneExportSettingId: Scalars["ID"]["input"];
};

export type QueryKintoneRecordMetadataByExportedRecordIdArgs = {
  kintoneExportedRecordId: Scalars["ID"]["input"];
};

export type QueryLatestQualifiedInvoiceArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type QueryLiveProcedureArgs = {
  orgSlug: Scalars["String"]["input"];
  procedureId: Scalars["ID"]["input"];
};

export type QueryMessagesArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryPayeasyPayloadArgs = {
  applicationId: Scalars["ID"]["input"];
  paymentId: Scalars["ID"]["input"];
};

export type QueryPaymentDetailByPaymentsArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type QueryPaymentSummaryArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type QueryPostPaymentLinkPurchaseRequestFormArgumentsArgs = {
  applicationId: Scalars["ID"]["input"];
  paymentIndex: Scalars["Int"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type QueryProceduresWithCustomPathArgs = {
  customPath: Scalars["String"]["input"];
  orgId: Scalars["String"]["input"];
};

export type QueryPublishingProcedureCountArgs = {
  orgId: Scalars["ID"]["input"];
};

export type QueryPublishingSurveyCountArgs = {
  orgId: Scalars["ID"]["input"];
};

export type QueryQualifiedInvoiceArgs = {
  applicationId: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
};

export type QueryQualifiedInvoiceDetailPaymentArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type QueryQualifiedInvoiceIssueControlStatusArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type QueryQualifiedInvoiceIssueRequestArgs = {
  applicationId: Scalars["ID"]["input"];
};

export type QueryRemovedApplicationWithProcedureArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryRemovedApplicationsArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
};

export type QuerySurveyAnswerCountByOrgIdArgs = {
  orgId: Scalars["ID"]["input"];
};

export type QuerySurveyAnswerDraftArgs = {
  input?: InputMaybe<GetSurveyAnswerDraftInput>;
};

export type QueryUnhandledQualifiedInvoiceIssueRequestsArgs = {
  orgId: Scalars["ID"]["input"];
};

export type QueryVerifyProcedureAccessSessionArgs = {
  sessionId: Scalars["String"]["input"];
};

export type RemoveSurveyAnswersResult = {
  __typename?: "RemoveSurveyAnswersResult";
  ok: Scalars["Boolean"]["output"];
};

export type RemovedApplication = {
  __typename?: "RemovedApplication";
  createdAt: Scalars["Time"]["output"];
  createdAtUnixSecond: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  procedureId: Scalars["ID"]["output"];
  procedureVersion: Scalars["Int"]["output"];
  removedAt: Scalars["Time"]["output"];
  status: Status;
  updatedAt: Scalars["Time"]["output"];
  updatedAtUnixSecond: Scalars["Int"]["output"];
  version: Scalars["Int"]["output"];
};

export type RemovedApplicationWithProcedure = {
  __typename?: "RemovedApplicationWithProcedure";
  procedure: Procedure;
  removedApplication: RemovedApplication;
};

export type RemovedApplicationsResult = {
  __typename?: "RemovedApplicationsResult";
  edges: Array<RemovedApplication>;
  pageInfo: PageInfo;
};

export type RequestKintoneExportInput = {
  settingId: Scalars["ID"]["input"];
  submissionIds: Array<Scalars["ID"]["input"]>;
  term?: InputMaybe<RequestKintoneExportInputTerm>;
};

export type RequestKintoneExportInputTerm = {
  fromUnixMilli: Scalars["Int"]["input"];
  toUnixMilli: Scalars["Int"]["input"];
};

export type RequestPayeasy = {
  amount: Scalars["Amount"]["input"];
  applicationID: Scalars["ID"]["input"];
  payeasyRequestDetail: PayeasyRequestDetail;
  paymentIndex: Scalars["Int"]["input"];
  version: Scalars["Int"]["input"];
};

export type RequireAuthLevel = {
  __typename?: "RequireAuthLevel";
  corporation: AuthLevelCorp;
  individual: AuthLevelIndividual;
};

export type RevertStatusCommand = {
  internalComment: Scalars["String"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  skipNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
  status: Status;
  version: Scalars["Int"]["input"];
};

export type RevertStatusMutationResult =
  | IsOutdatedAppVersion
  | ProcedureAplsReachedQuota
  | RevertStatusResult;

export type RevertStatusResult = {
  __typename?: "RevertStatusResult";
  ok: Scalars["Boolean"]["output"];
};

export type SchemaKey = {
  __typename?: "SchemaKey";
  formSchemaJsonPath: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type Signature = {
  __typename?: "Signature";
  certCheckResult: CertCheckResult;
  certificateType: CertificateEnum;
  contentStorageUrl: Scalars["String"]["output"];
  expectedHash: Scalars["String"]["output"];
  hashAlgOid: Scalars["String"]["output"];
  jpkiSubjectAltName: JpkiSubjectAltName;
  signature: Scalars["String"]["output"];
  signatureArrivedAt: Scalars["Time"]["output"];
  signedDataVersion: Scalars["String"]["output"];
};

export type Status =
  | "CLOSED_COMPLETED"
  | "CLOSED_REJECTED"
  | "CLOSED_WITHDRAWN"
  | "UNTREATED"
  | "WIP";

export type SurveyAnswerDraft = {
  __typename?: "SurveyAnswerDraft";
  answer: Scalars["Map"]["output"];
  files?: Maybe<Array<PreUploadFile>>;
  id: Scalars["ID"]["output"];
  surveyID: Scalars["ID"]["output"];
};

export type TaskStatus = "Fail" | "NotYet" | "Success";

export type TaskType = "BulkIssuePdfFile" | "BulkUpdateTenantProcessResult";

export type Template = {
  __typename?: "Template";
  formSchema: Scalars["Any"]["output"];
  pdfOutputSetting?: Maybe<PdfOutputSetting>;
  tenantProcessResultSetting?: Maybe<TenantProcessResultSetting>;
};

export type TenantProcessResultSetting = {
  __typename?: "TenantProcessResultSetting";
  inputElements: Scalars["Any"]["output"];
};

export type UnarchiveProcedureResult = {
  __typename?: "UnarchiveProcedureResult";
  ok: Scalars["Boolean"]["output"];
};

export type UnhandledQualifiedInvoiceIssueRequestResponse = {
  __typename?: "UnhandledQualifiedInvoiceIssueRequestResponse";
  applicationId: Scalars["ID"]["output"];
  applicationName: Scalars["String"]["output"];
  createdAt: Scalars["Time"]["output"];
  id: Scalars["ID"]["output"];
};

export type UpdateKintoneExportSettingInput = {
  description: Scalars["String"]["input"];
  disabled: Scalars["Boolean"]["input"];
  elementFieldMappings: Array<UpsertKintoneExportElementFieldMappingInput>;
  id: Scalars["ID"]["input"];
  kintoneAPIToken?: InputMaybe<Scalars["String"]["input"]>;
  metadataFieldMapping: UpsertKintoneExportMetadataFieldMappingInput;
  name: Scalars["String"]["input"];
};

export type UpdateSurveyAnswerDraftInput = {
  answer: Scalars["Map"]["input"];
  files?: InputMaybe<Array<PreUploadFileInput>>;
  id: Scalars["ID"]["input"];
  surveyID: Scalars["ID"]["input"];
};

export type UpsertKintoneExportElementFieldMappingInput = {
  formElementId: Scalars["String"]["input"];
  kintoneFieldCode: Scalars["String"]["input"];
};

export type UpsertKintoneExportMetadataFieldMappingInput = {
  procedureNameFieldCode?: InputMaybe<Scalars["String"]["input"]>;
  submissionIdFieldCode: Scalars["String"]["input"];
  submissionStatusFieldCode?: InputMaybe<Scalars["String"]["input"]>;
  submittedAtFieldCode: Scalars["String"]["input"];
};

export type UserAccessMethod = "EMAIL_AUTH" | "LOGIN" | "NONE";

export type UserMetaInfo = {
  __typename?: "UserMetaInfo";
  id: Scalars["ID"]["output"];
  userType: UserType;
};

export type UserMetaInfoWithName = {
  __typename?: "UserMetaInfoWithName";
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  userType: UserType;
};

export type UserType =
  | "CitizenUser"
  | "GrafferStaffUser"
  | "OrgUser"
  | "System";

export type ApplicantSchemaKeysEntityFragment = {
  __typename?: "ApplicantSchemaKeys";
  applicantSection: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantType: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantCorporateSearch: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantName: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantNameKana: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantPostalCode: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantAddress: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantBirthDate: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantTradeName: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantTradeNameKana: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantCorporateNumber: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantRepresentativeName: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantPhoneNumber: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantEmail: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
  applicantContactPersonal: {
    __typename?: "SchemaKey";
    formSchemaJsonPath: string;
    id: string;
  };
};

export type ApplicationEntityFragment = {
  __typename?: "Application";
  id: string;
  name: string;
  orgId: string;
  procedureId: string;
  procedureVersion: number;
  status: Status;
  userIdExists: boolean;
  jsonDocument: any;
  modifiedAt?: any | null;
  tenantProcessResult?: any | null;
  createdAt: any;
  updatedAt: any;
  createdAtUnixSecond: number;
  updatedAtUnixSecond: number;
  version: number;
  signature?: {
    __typename?: "Signature";
    certificateType: CertificateEnum;
    contentStorageUrl: string;
    signature: string;
    hashAlgOid: string;
    expectedHash: string;
    signatureArrivedAt: any;
    signedDataVersion: string;
    certCheckResult: {
      __typename?: "CertCheckResult";
      verifyTicket: string;
      isPending: boolean;
      isValid?: boolean | null;
      uid?: number | null;
      surrogate: string;
      asof: string;
      notBefore: string;
      notAfter: string;
      issuerDn: string;
      signatureId: string;
    };
    jpkiSubjectAltName: {
      __typename?: "JPKISubjectAltName";
      commonName: string;
      address: string;
      gender: any;
      dateOfBirth: string;
      substituteCharacterOfCommonName: string;
      substituteCharacterOfAddress: string;
    };
  } | null;
  files: Array<{
    __typename?: "AttachFileWithURL";
    refKey?: string | null;
    name: string;
    type: GrafferMimeType;
    size: number;
    tags?: Array<string> | null;
    url: string;
  }>;
  myNumbers?: Array<{
    __typename?: "MyNumberWithID";
    myNumberId: string;
    refKey: string;
    last4Digit?: string | null;
  }> | null;
  applicantContent?: {
    __typename?: "ApplicationContent";
    jsonDocument: any;
    modifiedAt?: any | null;
    files: Array<{
      __typename?: "AttachFileWithURL";
      refKey?: string | null;
      name: string;
      type: GrafferMimeType;
      size: number;
      tags?: Array<string> | null;
      url: string;
    }>;
    myNumbers?: Array<{
      __typename?: "MyNumberWithID";
      myNumberId: string;
      refKey: string;
      last4Digit?: string | null;
    }> | null;
  } | null;
  issueFiles: Array<{
    __typename?: "IssueFileWithURL";
    name: string;
    type: GrafferMimeType;
    isDeleted: boolean;
    isDownloaded: boolean;
    url: string;
  }>;
  paymentsV2?: Array<{
    __typename?: "PaymentSnapshot";
    amountCharged: number;
    amountRefunded: number;
    isCancelled: boolean;
    acceptedPaymentMethods: Array<PaymentMethod>;
    paymentId?: string | null;
    status: PaymentStatus;
    amount: number;
    amountDetail: any;
    taxAmount: number;
    taxAmountDetail: any;
    invoice: {
      __typename?: "Invoice";
      items: Array<{
        __typename?: "InvoiceItem";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
      }>;
    };
  }> | null;
};

export type ApplicationEventEntityFragment = {
  __typename?: "ApplicationEvent";
  id: string;
  transactionID: string;
  orgId: string;
  eventType: ApplicationEventType;
  applicationId: string;
  createdAt: any;
  data: any;
  createdBy: {
    __typename?: "UserMetaInfoWithName";
    id: string;
    userType: UserType;
    name?: string | null;
  };
};

export type ApplicationHistoryEntityFragment = {
  __typename?: "ApplicationHistory";
  id: string;
  orgId: string;
  applicationId: string;
  modificationType: ModificationType;
  jsonDocument: any;
  internalCommentId?: string | null;
  modifiedAt: any;
  files: Array<{
    __typename?: "AttachFileWithURL";
    refKey?: string | null;
    name: string;
    type: GrafferMimeType;
    size: number;
    tags?: Array<string> | null;
    url: string;
  }>;
  myNumbers?: Array<{
    __typename?: "MyNumberWithID";
    myNumberId: string;
    refKey: string;
    last4Digit?: string | null;
  }> | null;
  signature?: {
    __typename?: "Signature";
    certificateType: CertificateEnum;
    contentStorageUrl: string;
    signature: string;
    hashAlgOid: string;
    expectedHash: string;
    signatureArrivedAt: any;
    signedDataVersion: string;
    certCheckResult: {
      __typename?: "CertCheckResult";
      verifyTicket: string;
      isPending: boolean;
      isValid?: boolean | null;
      uid?: number | null;
      surrogate: string;
      asof: string;
      notBefore: string;
      notAfter: string;
      issuerDn: string;
      signatureId: string;
    };
    jpkiSubjectAltName: {
      __typename?: "JPKISubjectAltName";
      commonName: string;
      address: string;
      gender: any;
      dateOfBirth: string;
      substituteCharacterOfCommonName: string;
      substituteCharacterOfAddress: string;
    };
  } | null;
  modifiedBy: {
    __typename?: "UserMetaInfoWithName";
    id: string;
    userType: UserType;
    name?: string | null;
  };
};

export type ApplicationMessageEntityFragment = {
  __typename?: "Message";
  id: string;
  applicationId: string;
  operationType: OperationType;
  content: string;
  createdAt: any;
  createdBy: string;
};

export type InternalCommentEntityFragment = {
  __typename?: "InternalComment";
  id: string;
  applicationId: string;
  content: string;
  operationType: OperationType;
  createdAt: any;
  createdBy?: string | null;
};

export type KintoneExportSettingEntityFragment = {
  __typename?: "KintoneExportSetting";
  id: string;
  tenantId: string;
  name: string;
  description: string;
  disabled: boolean;
  formResourceId: string;
  kintoneAppId: string;
  kintoneSubdomain: string;
  createdAtUnixSecond: number;
  updatedAtUnixSecond: number;
  elementFieldMappings: Array<{
    __typename?: "KintoneExportElementFieldMapping";
    formElementId: string;
    kintoneFieldCode: string;
  }>;
  metadataFieldMapping: {
    __typename?: "KintoneExportMetadataFieldMapping";
    submissionIdFieldCode: string;
    submittedAtFieldCode: string;
    submissionStatusFieldCode?: string | null;
    procedureNameFieldCode?: string | null;
  };
};

export type KintoneExportedRecordEntityFragment = {
  __typename?: "KintoneExportedRecord";
  id: string;
  tenantId: string;
  exportSettingId: string;
  smartApplySubmissionId: string;
  kintoneAppId: string;
  kintoneRecordId: string;
  kintoneRecordRevision: string;
  createdAtUnixSecond: number;
};

export type KintoneExportReportEntityFragment = {
  __typename?: "KintoneExportReport";
  id: string;
  tenantId: string;
  exportSettingId: string;
  grafferTraceId: string;
  errorMessage?: string | null;
  startedAtUnixSecond: number;
  createdAtUnixSecond: number;
  details: Array<{
    __typename?: "KintoneExportReportDetail";
    smartApplySubmissionId: string;
    kintoneRecordId?: string | null;
    kintoneRecordRevision?: string | null;
    errorMessage?: string | null;
    skippedByAplStatus?: Status | null;
    aplStatusUpdate?: {
      __typename?: "KintoneExportAplStatusUpdateLog";
      before: Status;
      after: Status;
    } | null;
    existingRecord?: {
      __typename?: "KintoneExportReportDetailExistingRecord";
      kintoneRecordId: string;
      exportedRecordId: string;
    } | null;
  }>;
  submissionFilter: {
    __typename?: "KintoneExportReportSubmissionFilter";
    tenantId: string;
    formResourceId: string;
    fromUnixSecond: number;
    toUnixSecond: number;
  };
};

export type KintoneExportRequestEntityFragment = {
  __typename?: "KintoneExportRequest";
  id: string;
  tenantId: string;
  exportSettingId: string;
  status: KintoneExportRequestStatus;
  errorDetail: string;
  specifiedSubmissionIds: Array<string>;
  createdReportId: string;
  createdAtUnixSecond: number;
  updatedAtUnixSecond: number;
  term?: {
    __typename?: "KintoneExportRequestTerm";
    fromUnixMilli: number;
    toUnixMilli: number;
  } | null;
};

export type KintoneExportErrorDetailEntityFragment = {
  __typename?: "KintoneExportErrorDetail";
  id: string;
  smartApplySubmissionId: string;
  settingId: string;
  reportId: string;
  errors: Array<string>;
};

export type ProcedureEntityFragment = {
  __typename?: "Procedure";
  id: string;
  version: number;
  orgId: string;
  summary?: string | null;
  detailURL?: string | null;
  descriptionMarkdown: string;
  name: string;
  groupIds: Array<string>;
  publishStatus: PublishStatus;
  isGrafferManaged: boolean;
  isLinkTopPage: boolean;
  customTag?: any | null;
  isExcludeFromSearch: boolean;
  isSkipArrivalMail: boolean;
  updatedAt: any;
  publishSetting: {
    __typename?: "PublishSetting";
    startAcceptAt?: any | null;
    endAcceptAt?: any | null;
    publishAt?: any | null;
    unPublishAt?: any | null;
    isPausingAccept: boolean;
  };
  draft: {
    __typename?: "Detail";
    acceptAnyFile: boolean;
    template: {
      __typename?: "Template";
      formSchema: any;
      pdfOutputSetting?: {
        __typename?: "PDFOutputSetting";
        pdfOutputBaseFile?: any | null;
        pdfOutputBaseFileName: string;
        pdfOutputBaseFileURL: string;
        metaInfoFormSchema?: any | null;
      } | null;
    };
    paymentSetting?: {
      __typename?: "PaymentSettingV2";
      items: Array<{
        __typename?: "InvoiceItemSetting";
        formulaId: string;
        taxRate: TaxRateLiterals;
        description: string;
      }>;
    } | null;
    requireAuthLevel: {
      __typename?: "RequireAuthLevel";
      individual: AuthLevelIndividual;
      corporation: AuthLevelCorp;
    };
    applicantSchemaKeys: {
      __typename?: "ApplicantSchemaKeys";
      applicantSection: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantType: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantCorporateSearch: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantName: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantNameKana: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantPostalCode: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantAddress: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantBirthDate: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantTradeName: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantTradeNameKana: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantCorporateNumber: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantRepresentativeName: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantPhoneNumber: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantEmail: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantContactPersonal: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
    };
  };
  published?: {
    __typename?: "PublishedDetail";
    acceptAnyFile: boolean;
    template: {
      __typename?: "Template";
      formSchema: any;
      pdfOutputSetting?: {
        __typename?: "PDFOutputSetting";
        pdfOutputBaseFile?: any | null;
        pdfOutputBaseFileName: string;
        pdfOutputBaseFileURL: string;
        metaInfoFormSchema?: any | null;
      } | null;
      tenantProcessResultSetting?: {
        __typename?: "TenantProcessResultSetting";
        inputElements: any;
      } | null;
    };
    paymentSetting?: {
      __typename?: "PaymentSettingV2";
      items: Array<{
        __typename?: "InvoiceItemSetting";
        formulaId: string;
        taxRate: TaxRateLiterals;
        description: string;
      }>;
    } | null;
    requireAuthLevel: {
      __typename?: "RequireAuthLevel";
      individual: AuthLevelIndividual;
      corporation: AuthLevelCorp;
    };
    applicantSchemaKeys: {
      __typename?: "ApplicantSchemaKeys";
      applicantSection: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantType: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantCorporateSearch: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantName: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantNameKana: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantPostalCode: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantAddress: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantBirthDate: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantTradeName: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantTradeNameKana: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantCorporateNumber: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantRepresentativeName: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantPhoneNumber: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantEmail: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
      applicantContactPersonal: {
        __typename?: "SchemaKey";
        formSchemaJsonPath: string;
        id: string;
      };
    };
  } | null;
};

export type AdjustPaymentExceedingOrDeficiencyMutationVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
  version: Scalars["Int"]["input"];
  paymentIndex: Scalars["Int"]["input"];
}>;

export type AdjustPaymentExceedingOrDeficiencyMutation = {
  __typename?: "Mutation";
  adjustPaymentExceedingOrDeficiency: boolean;
};

export type ArchiveProcedureMutationVariables = Exact<{
  procedureId: Scalars["String"]["input"];
  previousUpdatedAtUnixTime: Scalars["Float"]["input"];
}>;

export type ArchiveProcedureMutation = {
  __typename?: "Mutation";
  archiveProcedure: { __typename?: "ArchiveProcedureResult"; ok: boolean };
};

export type RemoveSurveyAnswerMutationVariables = Exact<{
  surveyId: Scalars["ID"]["input"];
}>;

export type RemoveSurveyAnswerMutation = {
  __typename?: "Mutation";
  removeSurveyAnswers: {
    __typename?: "RemoveSurveyAnswersResult";
    ok: boolean;
  };
};

export type ApplicationQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ApplicationQuery = {
  __typename?: "Query";
  application: {
    __typename?: "Application";
    id: string;
    name: string;
    orgId: string;
    procedureId: string;
    procedureVersion: number;
    status: Status;
    userIdExists: boolean;
    jsonDocument: any;
    modifiedAt?: any | null;
    tenantProcessResult?: any | null;
    createdAt: any;
    updatedAt: any;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    version: number;
    signature?: {
      __typename?: "Signature";
      certificateType: CertificateEnum;
      contentStorageUrl: string;
      signature: string;
      hashAlgOid: string;
      expectedHash: string;
      signatureArrivedAt: any;
      signedDataVersion: string;
      certCheckResult: {
        __typename?: "CertCheckResult";
        verifyTicket: string;
        isPending: boolean;
        isValid?: boolean | null;
        uid?: number | null;
        surrogate: string;
        asof: string;
        notBefore: string;
        notAfter: string;
        issuerDn: string;
        signatureId: string;
      };
      jpkiSubjectAltName: {
        __typename?: "JPKISubjectAltName";
        commonName: string;
        address: string;
        gender: any;
        dateOfBirth: string;
        substituteCharacterOfCommonName: string;
        substituteCharacterOfAddress: string;
      };
    } | null;
    files: Array<{
      __typename?: "AttachFileWithURL";
      refKey?: string | null;
      name: string;
      type: GrafferMimeType;
      size: number;
      tags?: Array<string> | null;
      url: string;
    }>;
    myNumbers?: Array<{
      __typename?: "MyNumberWithID";
      myNumberId: string;
      refKey: string;
      last4Digit?: string | null;
    }> | null;
    applicantContent?: {
      __typename?: "ApplicationContent";
      jsonDocument: any;
      modifiedAt?: any | null;
      files: Array<{
        __typename?: "AttachFileWithURL";
        refKey?: string | null;
        name: string;
        type: GrafferMimeType;
        size: number;
        tags?: Array<string> | null;
        url: string;
      }>;
      myNumbers?: Array<{
        __typename?: "MyNumberWithID";
        myNumberId: string;
        refKey: string;
        last4Digit?: string | null;
      }> | null;
    } | null;
    issueFiles: Array<{
      __typename?: "IssueFileWithURL";
      name: string;
      type: GrafferMimeType;
      isDeleted: boolean;
      isDownloaded: boolean;
      url: string;
    }>;
    paymentsV2?: Array<{
      __typename?: "PaymentSnapshot";
      amountCharged: number;
      amountRefunded: number;
      isCancelled: boolean;
      acceptedPaymentMethods: Array<PaymentMethod>;
      paymentId?: string | null;
      status: PaymentStatus;
      amount: number;
      amountDetail: any;
      taxAmount: number;
      taxAmountDetail: any;
      invoice: {
        __typename?: "Invoice";
        items: Array<{
          __typename?: "InvoiceItem";
          type: InvoiceItemType;
          amount: number;
          taxRate: TaxRateLiterals;
          description: string;
        }>;
      };
    }> | null;
  };
};

export type ApplicationAndProcedureQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ApplicationAndProcedureQuery = {
  __typename?: "Query";
  applicationDetailData: {
    __typename?: "ApplicationDetailData";
    application: {
      __typename?: "Application";
      id: string;
      name: string;
      orgId: string;
      procedureId: string;
      procedureVersion: number;
      status: Status;
      userIdExists: boolean;
      jsonDocument: any;
      modifiedAt?: any | null;
      tenantProcessResult?: any | null;
      createdAt: any;
      updatedAt: any;
      createdAtUnixSecond: number;
      updatedAtUnixSecond: number;
      version: number;
      signature?: {
        __typename?: "Signature";
        certificateType: CertificateEnum;
        contentStorageUrl: string;
        signature: string;
        hashAlgOid: string;
        expectedHash: string;
        signatureArrivedAt: any;
        signedDataVersion: string;
        certCheckResult: {
          __typename?: "CertCheckResult";
          verifyTicket: string;
          isPending: boolean;
          isValid?: boolean | null;
          uid?: number | null;
          surrogate: string;
          asof: string;
          notBefore: string;
          notAfter: string;
          issuerDn: string;
          signatureId: string;
        };
        jpkiSubjectAltName: {
          __typename?: "JPKISubjectAltName";
          commonName: string;
          address: string;
          gender: any;
          dateOfBirth: string;
          substituteCharacterOfCommonName: string;
          substituteCharacterOfAddress: string;
        };
      } | null;
      files: Array<{
        __typename?: "AttachFileWithURL";
        refKey?: string | null;
        name: string;
        type: GrafferMimeType;
        size: number;
        tags?: Array<string> | null;
        url: string;
      }>;
      myNumbers?: Array<{
        __typename?: "MyNumberWithID";
        myNumberId: string;
        refKey: string;
        last4Digit?: string | null;
      }> | null;
      applicantContent?: {
        __typename?: "ApplicationContent";
        jsonDocument: any;
        modifiedAt?: any | null;
        files: Array<{
          __typename?: "AttachFileWithURL";
          refKey?: string | null;
          name: string;
          type: GrafferMimeType;
          size: number;
          tags?: Array<string> | null;
          url: string;
        }>;
        myNumbers?: Array<{
          __typename?: "MyNumberWithID";
          myNumberId: string;
          refKey: string;
          last4Digit?: string | null;
        }> | null;
      } | null;
      issueFiles: Array<{
        __typename?: "IssueFileWithURL";
        name: string;
        type: GrafferMimeType;
        isDeleted: boolean;
        isDownloaded: boolean;
        url: string;
      }>;
      paymentsV2?: Array<{
        __typename?: "PaymentSnapshot";
        amountCharged: number;
        amountRefunded: number;
        isCancelled: boolean;
        acceptedPaymentMethods: Array<PaymentMethod>;
        paymentId?: string | null;
        status: PaymentStatus;
        amount: number;
        amountDetail: any;
        taxAmount: number;
        taxAmountDetail: any;
        invoice: {
          __typename?: "Invoice";
          items: Array<{
            __typename?: "InvoiceItem";
            type: InvoiceItemType;
            amount: number;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        };
      }> | null;
    };
    procedure: {
      __typename?: "Procedure";
      id: string;
      version: number;
      orgId: string;
      summary?: string | null;
      detailURL?: string | null;
      descriptionMarkdown: string;
      name: string;
      groupIds: Array<string>;
      publishStatus: PublishStatus;
      isGrafferManaged: boolean;
      isLinkTopPage: boolean;
      customTag?: any | null;
      isExcludeFromSearch: boolean;
      isSkipArrivalMail: boolean;
      updatedAt: any;
      publishSetting: {
        __typename?: "PublishSetting";
        startAcceptAt?: any | null;
        endAcceptAt?: any | null;
        publishAt?: any | null;
        unPublishAt?: any | null;
        isPausingAccept: boolean;
      };
      draft: {
        __typename?: "Detail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      };
      published?: {
        __typename?: "PublishedDetail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
          tenantProcessResultSetting?: {
            __typename?: "TenantProcessResultSetting";
            inputElements: any;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      } | null;
    };
  };
};

export type ApplicationAllDetailDataQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  typedId: Scalars["ID"]["input"];
}>;

export type ApplicationAllDetailDataQuery = {
  __typename?: "Query";
  applicationDetailData: {
    __typename?: "ApplicationDetailData";
    procedure: {
      __typename?: "Procedure";
      id: string;
      version: number;
      orgId: string;
      summary?: string | null;
      detailURL?: string | null;
      descriptionMarkdown: string;
      name: string;
      groupIds: Array<string>;
      publishStatus: PublishStatus;
      isGrafferManaged: boolean;
      isLinkTopPage: boolean;
      customTag?: any | null;
      isExcludeFromSearch: boolean;
      isSkipArrivalMail: boolean;
      updatedAt: any;
      publishSetting: {
        __typename?: "PublishSetting";
        startAcceptAt?: any | null;
        endAcceptAt?: any | null;
        publishAt?: any | null;
        unPublishAt?: any | null;
        isPausingAccept: boolean;
      };
      draft: {
        __typename?: "Detail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      };
      published?: {
        __typename?: "PublishedDetail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
          tenantProcessResultSetting?: {
            __typename?: "TenantProcessResultSetting";
            inputElements: any;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      } | null;
    };
  };
  applicationHistories: Array<{
    __typename?: "ApplicationHistoryAndComment";
    applicationHistory: {
      __typename?: "ApplicationHistory";
      id: string;
      orgId: string;
      applicationId: string;
      modificationType: ModificationType;
      jsonDocument: any;
      internalCommentId?: string | null;
      modifiedAt: any;
      files: Array<{
        __typename?: "AttachFileWithURL";
        refKey?: string | null;
        name: string;
        type: GrafferMimeType;
        size: number;
        tags?: Array<string> | null;
        url: string;
      }>;
      myNumbers?: Array<{
        __typename?: "MyNumberWithID";
        myNumberId: string;
        refKey: string;
        last4Digit?: string | null;
      }> | null;
      signature?: {
        __typename?: "Signature";
        certificateType: CertificateEnum;
        contentStorageUrl: string;
        signature: string;
        hashAlgOid: string;
        expectedHash: string;
        signatureArrivedAt: any;
        signedDataVersion: string;
        certCheckResult: {
          __typename?: "CertCheckResult";
          verifyTicket: string;
          isPending: boolean;
          isValid?: boolean | null;
          uid?: number | null;
          surrogate: string;
          asof: string;
          notBefore: string;
          notAfter: string;
          issuerDn: string;
          signatureId: string;
        };
        jpkiSubjectAltName: {
          __typename?: "JPKISubjectAltName";
          commonName: string;
          address: string;
          gender: any;
          dateOfBirth: string;
          substituteCharacterOfCommonName: string;
          substituteCharacterOfAddress: string;
        };
      } | null;
      modifiedBy: {
        __typename?: "UserMetaInfoWithName";
        id: string;
        userType: UserType;
        name?: string | null;
      };
    };
    internalComment?: {
      __typename?: "InternalComment";
      id: string;
      applicationId: string;
      content: string;
      operationType: OperationType;
      createdAt: any;
      createdBy?: string | null;
    } | null;
  }>;
  applicationEventsAndMessages: {
    __typename?: "ApplicationEventsAndMessages";
    events: Array<{
      __typename?: "ApplicationEvent";
      id: string;
      transactionID: string;
      orgId: string;
      eventType: ApplicationEventType;
      applicationId: string;
      createdAt: any;
      data: any;
      createdBy: {
        __typename?: "UserMetaInfoWithName";
        id: string;
        userType: UserType;
        name?: string | null;
      };
    }>;
    messages: Array<{
      __typename?: "Message";
      id: string;
      applicationId: string;
      operationType: OperationType;
      content: string;
      createdAt: any;
      createdBy: string;
    }>;
  };
  internalCommentsAndUsers: Array<{
    __typename?: "InternalCommentAndUser";
    id: string;
    content: string;
    operationType: OperationType;
    createdAt: any;
    createdBy?: { __typename?: "InternalCommentOrgUser"; name: string } | null;
  }>;
  paymentSummary: {
    __typename?: "PaymentSummary";
    amount: number;
    amountRefunded: number;
    amountDetail?: any | null;
    taxAmountDetail?: any | null;
    invoice: {
      __typename?: "FixedInvoice";
      items: Array<{
        __typename?: "FixedInvoiceItem";
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
        operationType: PaymentOperationType;
        fixedAt: any;
      }>;
    };
    adjustmentRequiredDetail?: {
      __typename?: "AdjustmentRequiredDetail";
      exceeding?: number | null;
      deficiency?: number | null;
    } | null;
    operations: Array<{
      __typename?: "PaymentOperation";
      paymentTransactionType: PaymentOperationType;
      applicationId: string;
      paymentId: string;
      amount: number;
      createdAt: any;
      items: Array<{
        __typename?: "InvoiceItem";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
      }>;
    }>;
  };
  paymentDetailByPayments: Array<{
    __typename?: "PaymentDetail";
    paymentId: string;
    amount: number;
    amountRefunded: number;
    amountDetail?: any | null;
    taxAmountDetail?: any | null;
    paymentMethods?: Array<PaymentMethod> | null;
    isRefundablePaymentMethod: boolean;
    invoice: {
      __typename?: "InvoiceWithRefundableAmount";
      items: Array<{
        __typename?: "InvoiceItemWithRefundableAmount";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
        refundableAmount: number;
      }>;
    };
    adjustmentRequiredDetail?: {
      __typename?: "AdjustmentRequiredDetail";
      exceeding?: number | null;
      deficiency?: number | null;
    } | null;
    payeasyDetail?: Array<{
      __typename?: "PayeasyDetail";
      invoiceNo: string;
      billDate: string;
      skNo: string;
      customerNum: string;
      confirmationNum: string;
      paidAmount: number;
      expiredAt?: number | null;
      isPaid: boolean;
      isExpiredWithNoPayment: boolean;
    }> | null;
  }>;
};

export type GetApplicationsByProcedureQueryVariables = Exact<{
  procedureId: Scalars["String"]["input"];
  page: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  from?: InputMaybe<Scalars["String"]["input"]>;
  to?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<Status> | Status>;
}>;

export type GetApplicationsByProcedureQuery = {
  __typename?: "Query";
  applicationsByProcedure: {
    __typename?: "PagedApplications";
    totalCount: number;
    applications: Array<{
      __typename?: "Application";
      id: string;
      name: string;
      orgId: string;
      procedureId: string;
      procedureVersion: number;
      status: Status;
      userIdExists: boolean;
      jsonDocument: any;
      modifiedAt?: any | null;
      tenantProcessResult?: any | null;
      createdAt: any;
      updatedAt: any;
      createdAtUnixSecond: number;
      updatedAtUnixSecond: number;
      version: number;
      signature?: {
        __typename?: "Signature";
        certificateType: CertificateEnum;
        contentStorageUrl: string;
        signature: string;
        hashAlgOid: string;
        expectedHash: string;
        signatureArrivedAt: any;
        signedDataVersion: string;
        certCheckResult: {
          __typename?: "CertCheckResult";
          verifyTicket: string;
          isPending: boolean;
          isValid?: boolean | null;
          uid?: number | null;
          surrogate: string;
          asof: string;
          notBefore: string;
          notAfter: string;
          issuerDn: string;
          signatureId: string;
        };
        jpkiSubjectAltName: {
          __typename?: "JPKISubjectAltName";
          commonName: string;
          address: string;
          gender: any;
          dateOfBirth: string;
          substituteCharacterOfCommonName: string;
          substituteCharacterOfAddress: string;
        };
      } | null;
      files: Array<{
        __typename?: "AttachFileWithURL";
        refKey?: string | null;
        name: string;
        type: GrafferMimeType;
        size: number;
        tags?: Array<string> | null;
        url: string;
      }>;
      myNumbers?: Array<{
        __typename?: "MyNumberWithID";
        myNumberId: string;
        refKey: string;
        last4Digit?: string | null;
      }> | null;
      applicantContent?: {
        __typename?: "ApplicationContent";
        jsonDocument: any;
        modifiedAt?: any | null;
        files: Array<{
          __typename?: "AttachFileWithURL";
          refKey?: string | null;
          name: string;
          type: GrafferMimeType;
          size: number;
          tags?: Array<string> | null;
          url: string;
        }>;
        myNumbers?: Array<{
          __typename?: "MyNumberWithID";
          myNumberId: string;
          refKey: string;
          last4Digit?: string | null;
        }> | null;
      } | null;
      issueFiles: Array<{
        __typename?: "IssueFileWithURL";
        name: string;
        type: GrafferMimeType;
        isDeleted: boolean;
        isDownloaded: boolean;
        url: string;
      }>;
      paymentsV2?: Array<{
        __typename?: "PaymentSnapshot";
        amountCharged: number;
        amountRefunded: number;
        isCancelled: boolean;
        acceptedPaymentMethods: Array<PaymentMethod>;
        paymentId?: string | null;
        status: PaymentStatus;
        amount: number;
        amountDetail: any;
        taxAmount: number;
        taxAmountDetail: any;
        invoice: {
          __typename?: "Invoice";
          items: Array<{
            __typename?: "InvoiceItem";
            type: InvoiceItemType;
            amount: number;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        };
      }> | null;
    }>;
    procedure: {
      __typename?: "Procedure";
      id: string;
      version: number;
      orgId: string;
      summary?: string | null;
      detailURL?: string | null;
      descriptionMarkdown: string;
      name: string;
      groupIds: Array<string>;
      publishStatus: PublishStatus;
      isGrafferManaged: boolean;
      isLinkTopPage: boolean;
      customTag?: any | null;
      isExcludeFromSearch: boolean;
      isSkipArrivalMail: boolean;
      updatedAt: any;
      publishSetting: {
        __typename?: "PublishSetting";
        startAcceptAt?: any | null;
        endAcceptAt?: any | null;
        publishAt?: any | null;
        unPublishAt?: any | null;
        isPausingAccept: boolean;
      };
      draft: {
        __typename?: "Detail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      };
      published?: {
        __typename?: "PublishedDetail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
          tenantProcessResultSetting?: {
            __typename?: "TenantProcessResultSetting";
            inputElements: any;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      } | null;
    };
  };
};

export type ApplicationEventsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ApplicationEventsQuery = {
  __typename?: "Query";
  applicationEventsAndMessages: {
    __typename?: "ApplicationEventsAndMessages";
    events: Array<{
      __typename?: "ApplicationEvent";
      id: string;
      transactionID: string;
      orgId: string;
      eventType: ApplicationEventType;
      applicationId: string;
      createdAt: any;
      data: any;
      createdBy: {
        __typename?: "UserMetaInfoWithName";
        id: string;
        userType: UserType;
        name?: string | null;
      };
    }>;
  };
};

export type ApplicationEventsAndMessagesQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ApplicationEventsAndMessagesQuery = {
  __typename?: "Query";
  applicationEventsAndMessages: {
    __typename?: "ApplicationEventsAndMessages";
    events: Array<{
      __typename?: "ApplicationEvent";
      id: string;
      transactionID: string;
      orgId: string;
      eventType: ApplicationEventType;
      applicationId: string;
      createdAt: any;
      data: any;
      createdBy: {
        __typename?: "UserMetaInfoWithName";
        id: string;
        userType: UserType;
        name?: string | null;
      };
    }>;
    messages: Array<{
      __typename?: "Message";
      id: string;
      applicationId: string;
      operationType: OperationType;
      content: string;
      createdAt: any;
      createdBy: string;
    }>;
  };
};

export type ApplicationHistoriesQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ApplicationHistoriesQuery = {
  __typename?: "Query";
  applicationHistories: Array<{
    __typename?: "ApplicationHistoryAndComment";
    applicationHistory: {
      __typename?: "ApplicationHistory";
      id: string;
      orgId: string;
      applicationId: string;
      modificationType: ModificationType;
      jsonDocument: any;
      internalCommentId?: string | null;
      modifiedAt: any;
      files: Array<{
        __typename?: "AttachFileWithURL";
        refKey?: string | null;
        name: string;
        type: GrafferMimeType;
        size: number;
        tags?: Array<string> | null;
        url: string;
      }>;
      myNumbers?: Array<{
        __typename?: "MyNumberWithID";
        myNumberId: string;
        refKey: string;
        last4Digit?: string | null;
      }> | null;
      signature?: {
        __typename?: "Signature";
        certificateType: CertificateEnum;
        contentStorageUrl: string;
        signature: string;
        hashAlgOid: string;
        expectedHash: string;
        signatureArrivedAt: any;
        signedDataVersion: string;
        certCheckResult: {
          __typename?: "CertCheckResult";
          verifyTicket: string;
          isPending: boolean;
          isValid?: boolean | null;
          uid?: number | null;
          surrogate: string;
          asof: string;
          notBefore: string;
          notAfter: string;
          issuerDn: string;
          signatureId: string;
        };
        jpkiSubjectAltName: {
          __typename?: "JPKISubjectAltName";
          commonName: string;
          address: string;
          gender: any;
          dateOfBirth: string;
          substituteCharacterOfCommonName: string;
          substituteCharacterOfAddress: string;
        };
      } | null;
      modifiedBy: {
        __typename?: "UserMetaInfoWithName";
        id: string;
        userType: UserType;
        name?: string | null;
      };
    };
    internalComment?: {
      __typename?: "InternalComment";
      id: string;
      applicationId: string;
      content: string;
      operationType: OperationType;
      createdAt: any;
      createdBy?: string | null;
    } | null;
  }>;
};

export type ApplicationTaskAndUserQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ApplicationTaskAndUserQuery = {
  __typename?: "Query";
  applicationTaskAndUser: {
    __typename?: "ApplicationTaskAndUser";
    id: string;
    orgId: string;
    taskType: TaskType;
    createdAt: any;
    updatedAt: any;
    taskDetails: Array<{
      __typename?: "ApplicationTaskDetail";
      applicationId: string;
      taskStatus: TaskStatus;
      errCode?: string | null;
    }>;
    user: { __typename?: "ApplicationTaskOrgUser"; name: string };
  };
};

export type GetApplicationsWithApplicantSchemaKeysQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  sort: ApplicationsWithApplicationSchemaKeysSort;
  from?: InputMaybe<Scalars["String"]["input"]>;
  to?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<Status> | Status>;
}>;

export type GetApplicationsWithApplicantSchemaKeysQuery = {
  __typename?: "Query";
  applicationsWithApplicantSchemaKeys: {
    __typename?: "ApplicationsWithApplicantSchemaKeys";
    totalCount: number;
    applications: Array<{
      __typename?: "ApplicationWithApplicantSchemaKeys";
      application: {
        __typename?: "Application";
        id: string;
        name: string;
        orgId: string;
        procedureId: string;
        procedureVersion: number;
        status: Status;
        userIdExists: boolean;
        jsonDocument: any;
        modifiedAt?: any | null;
        tenantProcessResult?: any | null;
        createdAt: any;
        updatedAt: any;
        createdAtUnixSecond: number;
        updatedAtUnixSecond: number;
        version: number;
        signature?: {
          __typename?: "Signature";
          certificateType: CertificateEnum;
          contentStorageUrl: string;
          signature: string;
          hashAlgOid: string;
          expectedHash: string;
          signatureArrivedAt: any;
          signedDataVersion: string;
          certCheckResult: {
            __typename?: "CertCheckResult";
            verifyTicket: string;
            isPending: boolean;
            isValid?: boolean | null;
            uid?: number | null;
            surrogate: string;
            asof: string;
            notBefore: string;
            notAfter: string;
            issuerDn: string;
            signatureId: string;
          };
          jpkiSubjectAltName: {
            __typename?: "JPKISubjectAltName";
            commonName: string;
            address: string;
            gender: any;
            dateOfBirth: string;
            substituteCharacterOfCommonName: string;
            substituteCharacterOfAddress: string;
          };
        } | null;
        files: Array<{
          __typename?: "AttachFileWithURL";
          refKey?: string | null;
          name: string;
          type: GrafferMimeType;
          size: number;
          tags?: Array<string> | null;
          url: string;
        }>;
        myNumbers?: Array<{
          __typename?: "MyNumberWithID";
          myNumberId: string;
          refKey: string;
          last4Digit?: string | null;
        }> | null;
        applicantContent?: {
          __typename?: "ApplicationContent";
          jsonDocument: any;
          modifiedAt?: any | null;
          files: Array<{
            __typename?: "AttachFileWithURL";
            refKey?: string | null;
            name: string;
            type: GrafferMimeType;
            size: number;
            tags?: Array<string> | null;
            url: string;
          }>;
          myNumbers?: Array<{
            __typename?: "MyNumberWithID";
            myNumberId: string;
            refKey: string;
            last4Digit?: string | null;
          }> | null;
        } | null;
        issueFiles: Array<{
          __typename?: "IssueFileWithURL";
          name: string;
          type: GrafferMimeType;
          isDeleted: boolean;
          isDownloaded: boolean;
          url: string;
        }>;
        paymentsV2?: Array<{
          __typename?: "PaymentSnapshot";
          amountCharged: number;
          amountRefunded: number;
          isCancelled: boolean;
          acceptedPaymentMethods: Array<PaymentMethod>;
          paymentId?: string | null;
          status: PaymentStatus;
          amount: number;
          amountDetail: any;
          taxAmount: number;
          taxAmountDetail: any;
          invoice: {
            __typename?: "Invoice";
            items: Array<{
              __typename?: "InvoiceItem";
              type: InvoiceItemType;
              amount: number;
              taxRate: TaxRateLiterals;
              description: string;
            }>;
          };
        }> | null;
      };
      applicantSchemaKeys: {
        __typename?: "ApplicantSchemaKeys";
        applicantSection: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantType: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantCorporateSearch: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantName: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantNameKana: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantPostalCode: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantAddress: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantBirthDate: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantTradeName: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantTradeNameKana: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantCorporateNumber: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantRepresentativeName: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantPhoneNumber: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantEmail: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantContactPersonal: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
      };
    }>;
  };
};

export type GetAssignedApplicationsQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  sort: ApplicationsWithApplicationSchemaKeysSort;
  from?: InputMaybe<Scalars["String"]["input"]>;
  to?: InputMaybe<Scalars["String"]["input"]>;
  procedureId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<Status> | Status>;
}>;

export type GetAssignedApplicationsQuery = {
  __typename?: "Query";
  assignedApplications: {
    __typename?: "ApplicationsWithApplicantSchemaKeys";
    totalCount: number;
    applications: Array<{
      __typename?: "ApplicationWithApplicantSchemaKeys";
      application: {
        __typename?: "Application";
        id: string;
        name: string;
        orgId: string;
        procedureId: string;
        procedureVersion: number;
        status: Status;
        userIdExists: boolean;
        jsonDocument: any;
        modifiedAt?: any | null;
        tenantProcessResult?: any | null;
        createdAt: any;
        updatedAt: any;
        createdAtUnixSecond: number;
        updatedAtUnixSecond: number;
        version: number;
        signature?: {
          __typename?: "Signature";
          certificateType: CertificateEnum;
          contentStorageUrl: string;
          signature: string;
          hashAlgOid: string;
          expectedHash: string;
          signatureArrivedAt: any;
          signedDataVersion: string;
          certCheckResult: {
            __typename?: "CertCheckResult";
            verifyTicket: string;
            isPending: boolean;
            isValid?: boolean | null;
            uid?: number | null;
            surrogate: string;
            asof: string;
            notBefore: string;
            notAfter: string;
            issuerDn: string;
            signatureId: string;
          };
          jpkiSubjectAltName: {
            __typename?: "JPKISubjectAltName";
            commonName: string;
            address: string;
            gender: any;
            dateOfBirth: string;
            substituteCharacterOfCommonName: string;
            substituteCharacterOfAddress: string;
          };
        } | null;
        files: Array<{
          __typename?: "AttachFileWithURL";
          refKey?: string | null;
          name: string;
          type: GrafferMimeType;
          size: number;
          tags?: Array<string> | null;
          url: string;
        }>;
        myNumbers?: Array<{
          __typename?: "MyNumberWithID";
          myNumberId: string;
          refKey: string;
          last4Digit?: string | null;
        }> | null;
        applicantContent?: {
          __typename?: "ApplicationContent";
          jsonDocument: any;
          modifiedAt?: any | null;
          files: Array<{
            __typename?: "AttachFileWithURL";
            refKey?: string | null;
            name: string;
            type: GrafferMimeType;
            size: number;
            tags?: Array<string> | null;
            url: string;
          }>;
          myNumbers?: Array<{
            __typename?: "MyNumberWithID";
            myNumberId: string;
            refKey: string;
            last4Digit?: string | null;
          }> | null;
        } | null;
        issueFiles: Array<{
          __typename?: "IssueFileWithURL";
          name: string;
          type: GrafferMimeType;
          isDeleted: boolean;
          isDownloaded: boolean;
          url: string;
        }>;
        paymentsV2?: Array<{
          __typename?: "PaymentSnapshot";
          amountCharged: number;
          amountRefunded: number;
          isCancelled: boolean;
          acceptedPaymentMethods: Array<PaymentMethod>;
          paymentId?: string | null;
          status: PaymentStatus;
          amount: number;
          amountDetail: any;
          taxAmount: number;
          taxAmountDetail: any;
          invoice: {
            __typename?: "Invoice";
            items: Array<{
              __typename?: "InvoiceItem";
              type: InvoiceItemType;
              amount: number;
              taxRate: TaxRateLiterals;
              description: string;
            }>;
          };
        }> | null;
      };
      applicantSchemaKeys: {
        __typename?: "ApplicantSchemaKeys";
        applicantSection: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantType: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantCorporateSearch: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantName: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantNameKana: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantPostalCode: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantAddress: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantBirthDate: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantTradeName: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantTradeNameKana: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantCorporateNumber: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantRepresentativeName: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantPhoneNumber: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantEmail: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
        applicantContactPersonal: {
          __typename?: "SchemaKey";
          formSchemaJsonPath: string;
          id: string;
        };
      };
    }>;
  };
};

export type InternalCommentsAndUsersQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type InternalCommentsAndUsersQuery = {
  __typename?: "Query";
  internalCommentsAndUsers: Array<{
    __typename?: "InternalCommentAndUser";
    id: string;
    content: string;
    operationType: OperationType;
    createdAt: any;
    createdBy?: { __typename?: "InternalCommentOrgUser"; name: string } | null;
  }>;
};

export type GetLatestQualifiedInvoiceQueryVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
}>;

export type GetLatestQualifiedInvoiceQuery = {
  __typename?: "Query";
  latestQualifiedInvoice?: {
    __typename?: "QualifiedInvoice";
    id: string;
    applicationId: string;
    detail: {
      __typename?: "QualifiedInvoiceDetail";
      buyerName?: string | null;
      qualifiedInvoiceBusinessIssuer: {
        __typename?: "QualifiedInvoiceDetailBusinessIssuer";
        name: string;
        registrationNumber: any;
      };
      transactionDate: {
        __typename?: "QualifiedInvoiceTransactionDate";
        year: number;
        month: number;
        day: number;
      };
      payment: {
        __typename?: "QualifiedInvoiceDetailPayment";
        amount: number;
        amountDetail: any;
        taxAmountDetail: any;
        items: Array<{
          __typename?: "QualifiedInvoiceDetailPaymentItem";
          amount: number;
          taxRate: TaxRateLiterals;
          description: string;
        }>;
      };
    };
  } | null;
};

export type MessagesQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type MessagesQuery = {
  __typename?: "Query";
  messages: Array<{
    __typename?: "Message";
    id: string;
    content: string;
    operationType: OperationType;
    createdAt: any;
    createdBy: string;
  }>;
};

export type PaymentSummaryQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type PaymentSummaryQuery = {
  __typename?: "Query";
  paymentSummary: {
    __typename?: "PaymentSummary";
    amount: number;
    amountRefunded: number;
    amountDetail?: any | null;
    taxAmountDetail?: any | null;
    invoice: {
      __typename?: "FixedInvoice";
      items: Array<{
        __typename?: "FixedInvoiceItem";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
        operationType: PaymentOperationType;
        fixedAt: any;
      }>;
    };
    adjustmentRequiredDetail?: {
      __typename?: "AdjustmentRequiredDetail";
      deficiency?: number | null;
      exceeding?: number | null;
    } | null;
    operations: Array<{
      __typename?: "PaymentOperation";
      paymentTransactionType: PaymentOperationType;
      applicationId: string;
      paymentId: string;
      amount: number;
      createdAt: any;
      items: Array<{
        __typename?: "InvoiceItem";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
      }>;
    }>;
  };
};

export type PaymentDetailsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type PaymentDetailsQuery = {
  __typename?: "Query";
  paymentSummary: {
    __typename?: "PaymentSummary";
    amount: number;
    amountRefunded: number;
    amountDetail?: any | null;
    taxAmountDetail?: any | null;
    invoice: {
      __typename?: "FixedInvoice";
      items: Array<{
        __typename?: "FixedInvoiceItem";
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
        operationType: PaymentOperationType;
        fixedAt: any;
      }>;
    };
    adjustmentRequiredDetail?: {
      __typename?: "AdjustmentRequiredDetail";
      exceeding?: number | null;
      deficiency?: number | null;
    } | null;
    operations: Array<{
      __typename?: "PaymentOperation";
      paymentTransactionType: PaymentOperationType;
      applicationId: string;
      paymentId: string;
      amount: number;
      createdAt: any;
      items: Array<{
        __typename?: "InvoiceItem";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
      }>;
    }>;
  };
  paymentDetailByPayments: Array<{
    __typename?: "PaymentDetail";
    paymentId: string;
    amount: number;
    amountRefunded: number;
    amountDetail?: any | null;
    taxAmountDetail?: any | null;
    paymentMethods?: Array<PaymentMethod> | null;
    isRefundablePaymentMethod: boolean;
    invoice: {
      __typename?: "InvoiceWithRefundableAmount";
      items: Array<{
        __typename?: "InvoiceItemWithRefundableAmount";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
        refundableAmount: number;
      }>;
    };
    adjustmentRequiredDetail?: {
      __typename?: "AdjustmentRequiredDetail";
      exceeding?: number | null;
      deficiency?: number | null;
    } | null;
    payeasyDetail?: Array<{
      __typename?: "PayeasyDetail";
      invoiceNo: string;
      billDate: string;
      skNo: string;
      customerNum: string;
      confirmationNum: string;
      paidAmount: number;
      expiredAt?: number | null;
      isPaid: boolean;
      isExpiredWithNoPayment: boolean;
    }> | null;
  }>;
};

export type ProceduresWithCustomPathQueryVariables = Exact<{
  path: Scalars["String"]["input"];
  orgId: Scalars["String"]["input"];
}>;

export type ProceduresWithCustomPathQuery = {
  __typename?: "Query";
  proceduresWithCustomPath?: {
    __typename?: "ProceduresWithCustomPathResult";
    procUsingCustomPath?: {
      __typename?: "Procedure";
      id: string;
      version: number;
      orgId: string;
      summary?: string | null;
      detailURL?: string | null;
      descriptionMarkdown: string;
      name: string;
      groupIds: Array<string>;
      publishStatus: PublishStatus;
      isGrafferManaged: boolean;
      isLinkTopPage: boolean;
      customTag?: any | null;
      isExcludeFromSearch: boolean;
      isSkipArrivalMail: boolean;
      updatedAt: any;
      publishSetting: {
        __typename?: "PublishSetting";
        startAcceptAt?: any | null;
        endAcceptAt?: any | null;
        publishAt?: any | null;
        unPublishAt?: any | null;
        isPausingAccept: boolean;
      };
      draft: {
        __typename?: "Detail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      };
      published?: {
        __typename?: "PublishedDetail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
          tenantProcessResultSetting?: {
            __typename?: "TenantProcessResultSetting";
            inputElements: any;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      } | null;
    } | null;
    procHasReservedCustomPath?: {
      __typename?: "Procedure";
      id: string;
      version: number;
      orgId: string;
      summary?: string | null;
      detailURL?: string | null;
      descriptionMarkdown: string;
      name: string;
      groupIds: Array<string>;
      publishStatus: PublishStatus;
      isGrafferManaged: boolean;
      isLinkTopPage: boolean;
      customTag?: any | null;
      isExcludeFromSearch: boolean;
      isSkipArrivalMail: boolean;
      updatedAt: any;
      publishSetting: {
        __typename?: "PublishSetting";
        startAcceptAt?: any | null;
        endAcceptAt?: any | null;
        publishAt?: any | null;
        unPublishAt?: any | null;
        isPausingAccept: boolean;
      };
      draft: {
        __typename?: "Detail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      };
      published?: {
        __typename?: "PublishedDetail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
          tenantProcessResultSetting?: {
            __typename?: "TenantProcessResultSetting";
            inputElements: any;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      } | null;
    } | null;
  } | null;
};

export type CurrentCustomPathsQueryVariables = Exact<{
  orgId: Scalars["String"]["input"];
  procedureId: Scalars["String"]["input"];
}>;

export type CurrentCustomPathsQuery = {
  __typename?: "Query";
  currentCustomPaths: {
    __typename?: "CurrentCustomPaths";
    currentCustomPath?: {
      __typename?: "CustomPath";
      orgId: string;
      procedureId: string;
      customPath: string;
      startUnixtime: number;
    } | null;
    nextCustomPath?: {
      __typename?: "CustomPath";
      orgId: string;
      procedureId: string;
      customPath: string;
      startUnixtime: number;
    } | null;
  };
};

export type AssignedApplicationsProceduresQueryVariables = Exact<{
  name?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AssignedApplicationsProceduresQuery = {
  __typename?: "Query";
  assignedApplicationsProcedures: {
    __typename?: "AssignedApplicationsProceduresResponse";
    procedures: Array<{
      __typename?: "BaseProcedure";
      id: string;
      name: string;
    }>;
  };
};

export type GetQualifiedInvoiceQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  applicationId: Scalars["ID"]["input"];
}>;

export type GetQualifiedInvoiceQuery = {
  __typename?: "Query";
  qualifiedInvoice?: {
    __typename?: "QualifiedInvoice";
    id: string;
    applicationId: string;
    detail: {
      __typename?: "QualifiedInvoiceDetail";
      buyerName?: string | null;
      qualifiedInvoiceBusinessIssuer: {
        __typename?: "QualifiedInvoiceDetailBusinessIssuer";
        name: string;
        registrationNumber: any;
      };
      transactionDate: {
        __typename?: "QualifiedInvoiceTransactionDate";
        year: number;
        month: number;
        day: number;
      };
      payment: {
        __typename?: "QualifiedInvoiceDetailPayment";
        amount: number;
        amountDetail: any;
        taxAmountDetail: any;
        items: Array<{
          __typename?: "QualifiedInvoiceDetailPaymentItem";
          amount: number;
          taxRate: TaxRateLiterals;
          description: string;
        }>;
      };
    };
  } | null;
};

export type GetQualifiedInvoiceDetailPaymentQueryVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
}>;

export type GetQualifiedInvoiceDetailPaymentQuery = {
  __typename?: "Query";
  qualifiedInvoiceDetailPayment?: {
    __typename?: "QualifiedInvoiceDetailPayment";
    amountDetail: any;
    taxAmountDetail: any;
    amount: number;
    items: Array<{
      __typename?: "QualifiedInvoiceDetailPaymentItem";
      amount: number;
      taxRate: TaxRateLiterals;
      description: string;
    }>;
  } | null;
};

export type GetQualifiedInvoiceIssueRequestQueryVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
}>;

export type GetQualifiedInvoiceIssueRequestQuery = {
  __typename?: "Query";
  qualifiedInvoiceIssueControlStatus: {
    __typename?: "QualifiedInvoiceIssueControlStatus";
    isIssuableProcedure: boolean;
    hasTaxablePayment: boolean;
    isPaymentCompleted: boolean;
    isIssuableApplicationStatus: boolean;
  };
  qualifiedInvoiceIssueRequest?: {
    __typename?: "QualifiedInvoiceIssueRequest";
    id: string;
    applicationId: string;
    withdrewAt?: any | null;
    availableIssuedQualifiedInvoice?: {
      __typename?: "QualifiedInvoiceIssueRequestIssuedQualifiedInvoice";
      id: string;
      issuedAt: any;
    } | null;
    revokedQualifiedInvoices: Array<{
      __typename?: "QualifiedInvoiceIssueRequestIssuedQualifiedInvoice";
      id: string;
      issuedAt: any;
    }>;
  } | null;
};

export type GetUnhandledQualifiedInvoiceIssueRequestsQueryVariables = Exact<{
  orgId: Scalars["ID"]["input"];
}>;

export type GetUnhandledQualifiedInvoiceIssueRequestsQuery = {
  __typename?: "Query";
  unhandledQualifiedInvoiceIssueRequests: Array<{
    __typename?: "UnhandledQualifiedInvoiceIssueRequestResponse";
    id: string;
    applicationId: string;
    applicationName: string;
    createdAt: any;
  }>;
};

export type IssueQualifiedInvoiceMutationVariables = Exact<{
  input: IssueQualifiedInvoiceInput;
}>;

export type IssueQualifiedInvoiceMutation = {
  __typename?: "Mutation";
  issueQualifiedInvoice: boolean;
};

export type KintoneExportSettingsQueryVariables = Exact<{
  tenantId: Scalars["String"]["input"];
  groupIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  page: KintoneExportResourcePage;
}>;

export type KintoneExportSettingsQuery = {
  __typename?: "Query";
  kintoneExportSettingsV2: {
    __typename?: "KintoneExportSettingConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "KintoneExportSettingEdge";
      node: {
        __typename?: "KintoneExportSetting";
        id: string;
        name: string;
        formResourceId: string;
        disabled: boolean;
      };
    }>;
  };
};

export type KintoneExportSettingQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type KintoneExportSettingQuery = {
  __typename?: "Query";
  kintoneExportSetting: {
    __typename?: "KintoneExportSetting";
    id: string;
    tenantId: string;
    name: string;
    description: string;
    disabled: boolean;
    formResourceId: string;
    kintoneAppId: string;
    kintoneSubdomain: string;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    elementFieldMappings: Array<{
      __typename?: "KintoneExportElementFieldMapping";
      formElementId: string;
      kintoneFieldCode: string;
    }>;
    metadataFieldMapping: {
      __typename?: "KintoneExportMetadataFieldMapping";
      submissionIdFieldCode: string;
      submittedAtFieldCode: string;
      submissionStatusFieldCode?: string | null;
      procedureNameFieldCode?: string | null;
    };
  };
};

export type KintoneExportedRecordsQueryVariables = Exact<{
  tenantId: Scalars["String"]["input"];
  kintoneExportSettingId: Scalars["ID"]["input"];
  page: KintoneExportResourcePage;
}>;

export type KintoneExportedRecordsQuery = {
  __typename?: "Query";
  kintoneExportedRecordsV2: {
    __typename?: "KintoneExportedRecordConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "KintoneExportedRecordEdge";
      node: {
        __typename?: "KintoneExportedRecord";
        id: string;
        tenantId: string;
        exportSettingId: string;
        smartApplySubmissionId: string;
        kintoneAppId: string;
        kintoneRecordId: string;
        kintoneRecordRevision: string;
        createdAtUnixSecond: number;
      };
    }>;
  };
};

export type KintoneExportReportsQueryVariables = Exact<{
  tenantId: Scalars["String"]["input"];
  kintoneExportSettingId: Scalars["ID"]["input"];
  page: KintoneExportResourcePage;
}>;

export type KintoneExportReportsQuery = {
  __typename?: "Query";
  kintoneExportReportsV2: {
    __typename?: "KintoneExportReportConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "KintoneExportReportEdge";
      node: {
        __typename?: "KintoneExportReport";
        id: string;
        startedAtUnixSecond: number;
        createdAtUnixSecond: number;
      };
    }>;
  };
};

export type KintoneFieldsBySettingIdQueryVariables = Exact<{
  settingId: Scalars["ID"]["input"];
}>;

export type KintoneFieldsBySettingIdQuery = {
  __typename?: "Query";
  kintoneFields: {
    __typename?: "KintoneFieldsResponse";
    properties: any;
    revision: string;
  };
};

export type KintoneExportReportQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  kintoneExportSettingId: Scalars["ID"]["input"];
}>;

export type KintoneExportReportQuery = {
  __typename?: "Query";
  kintoneExportReport: {
    __typename?: "KintoneExportReport";
    id: string;
    tenantId: string;
    exportSettingId: string;
    grafferTraceId: string;
    errorMessage?: string | null;
    startedAtUnixSecond: number;
    createdAtUnixSecond: number;
    details: Array<{
      __typename?: "KintoneExportReportDetail";
      smartApplySubmissionId: string;
      kintoneRecordId?: string | null;
      kintoneRecordRevision?: string | null;
      errorMessage?: string | null;
      skippedByAplStatus?: Status | null;
      aplStatusUpdate?: {
        __typename?: "KintoneExportAplStatusUpdateLog";
        before: Status;
        after: Status;
      } | null;
      existingRecord?: {
        __typename?: "KintoneExportReportDetailExistingRecord";
        kintoneRecordId: string;
        exportedRecordId: string;
      } | null;
    }>;
    submissionFilter: {
      __typename?: "KintoneExportReportSubmissionFilter";
      tenantId: string;
      formResourceId: string;
      fromUnixSecond: number;
      toUnixSecond: number;
    };
  };
  kintoneExportSetting: {
    __typename?: "KintoneExportSetting";
    id: string;
    tenantId: string;
    name: string;
    description: string;
    disabled: boolean;
    formResourceId: string;
    kintoneAppId: string;
    kintoneSubdomain: string;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    elementFieldMappings: Array<{
      __typename?: "KintoneExportElementFieldMapping";
      formElementId: string;
      kintoneFieldCode: string;
    }>;
    metadataFieldMapping: {
      __typename?: "KintoneExportMetadataFieldMapping";
      submissionIdFieldCode: string;
      submittedAtFieldCode: string;
      submissionStatusFieldCode?: string | null;
      procedureNameFieldCode?: string | null;
    };
  };
};

export type KintoneExportRequestQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type KintoneExportRequestQuery = {
  __typename?: "Query";
  kintoneExportRequest: {
    __typename?: "KintoneExportRequest";
    id: string;
    tenantId: string;
    exportSettingId: string;
    status: KintoneExportRequestStatus;
    errorDetail: string;
    specifiedSubmissionIds: Array<string>;
    createdReportId: string;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    term?: {
      __typename?: "KintoneExportRequestTerm";
      fromUnixMilli: number;
      toUnixMilli: number;
    } | null;
  };
};

export type KintoneExportErrorDetailsQueryVariables = Exact<{
  reportId: Scalars["ID"]["input"];
}>;

export type KintoneExportErrorDetailsQuery = {
  __typename?: "Query";
  kintoneExportErrorDetails: {
    __typename?: "KintoneExportErrorDetailConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "KintoneExportErrorDetailEdge";
      node: {
        __typename?: "KintoneExportErrorDetail";
        id: string;
        smartApplySubmissionId: string;
        settingId: string;
        reportId: string;
        errors: Array<string>;
      };
    }>;
  };
};

export type CreateKintoneExportSettingMutationVariables = Exact<{
  input: CreateKintoneExportSettingInput;
}>;

export type CreateKintoneExportSettingMutation = {
  __typename?: "Mutation";
  createKintoneExportSetting: {
    __typename?: "KintoneExportSetting";
    id: string;
    tenantId: string;
    name: string;
    description: string;
    disabled: boolean;
    formResourceId: string;
    kintoneAppId: string;
    kintoneSubdomain: string;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    elementFieldMappings: Array<{
      __typename?: "KintoneExportElementFieldMapping";
      formElementId: string;
      kintoneFieldCode: string;
    }>;
    metadataFieldMapping: {
      __typename?: "KintoneExportMetadataFieldMapping";
      submissionIdFieldCode: string;
      submittedAtFieldCode: string;
      submissionStatusFieldCode?: string | null;
      procedureNameFieldCode?: string | null;
    };
  };
};

export type UpdateKintoneExportSettingMutationVariables = Exact<{
  input: UpdateKintoneExportSettingInput;
}>;

export type UpdateKintoneExportSettingMutation = {
  __typename?: "Mutation";
  updateKintoneExportSetting: {
    __typename?: "KintoneExportSetting";
    id: string;
    tenantId: string;
    name: string;
    description: string;
    disabled: boolean;
    formResourceId: string;
    kintoneAppId: string;
    kintoneSubdomain: string;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    elementFieldMappings: Array<{
      __typename?: "KintoneExportElementFieldMapping";
      formElementId: string;
      kintoneFieldCode: string;
    }>;
    metadataFieldMapping: {
      __typename?: "KintoneExportMetadataFieldMapping";
      submissionIdFieldCode: string;
      submittedAtFieldCode: string;
      submissionStatusFieldCode?: string | null;
      procedureNameFieldCode?: string | null;
    };
  };
};

export type DeleteKintoneExportedRecordMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteKintoneExportedRecordMutation = {
  __typename?: "Mutation";
  deleteKintoneExportedRecord: {
    __typename?: "EmptyResult";
    msg: EmptyResultMsg;
  };
};

export type RequestKintoneExportMutationVariables = Exact<{
  input: RequestKintoneExportInput;
}>;

export type RequestKintoneExportMutation = {
  __typename?: "Mutation";
  requestKintoneExport: {
    __typename?: "KintoneExportRequest";
    id: string;
    tenantId: string;
    exportSettingId: string;
    status: KintoneExportRequestStatus;
    errorDetail: string;
    specifiedSubmissionIds: Array<string>;
    createdReportId: string;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    term?: {
      __typename?: "KintoneExportRequestTerm";
      fromUnixMilli: number;
      toUnixMilli: number;
    } | null;
  };
};

export type ApplicationPaymentDetailDataQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  typedId: Scalars["ID"]["input"];
}>;

export type ApplicationPaymentDetailDataQuery = {
  __typename?: "Query";
  applicationDetailData: {
    __typename?: "ApplicationDetailData";
    procedure: {
      __typename?: "Procedure";
      id: string;
      version: number;
      orgId: string;
      summary?: string | null;
      detailURL?: string | null;
      descriptionMarkdown: string;
      name: string;
      groupIds: Array<string>;
      publishStatus: PublishStatus;
      isGrafferManaged: boolean;
      isLinkTopPage: boolean;
      customTag?: any | null;
      isExcludeFromSearch: boolean;
      isSkipArrivalMail: boolean;
      updatedAt: any;
      publishSetting: {
        __typename?: "PublishSetting";
        startAcceptAt?: any | null;
        endAcceptAt?: any | null;
        publishAt?: any | null;
        unPublishAt?: any | null;
        isPausingAccept: boolean;
      };
      draft: {
        __typename?: "Detail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      };
      published?: {
        __typename?: "PublishedDetail";
        acceptAnyFile: boolean;
        template: {
          __typename?: "Template";
          formSchema: any;
          pdfOutputSetting?: {
            __typename?: "PDFOutputSetting";
            pdfOutputBaseFile?: any | null;
            pdfOutputBaseFileName: string;
            pdfOutputBaseFileURL: string;
            metaInfoFormSchema?: any | null;
          } | null;
          tenantProcessResultSetting?: {
            __typename?: "TenantProcessResultSetting";
            inputElements: any;
          } | null;
        };
        paymentSetting?: {
          __typename?: "PaymentSettingV2";
          items: Array<{
            __typename?: "InvoiceItemSetting";
            formulaId: string;
            taxRate: TaxRateLiterals;
            description: string;
          }>;
        } | null;
        requireAuthLevel: {
          __typename?: "RequireAuthLevel";
          individual: AuthLevelIndividual;
          corporation: AuthLevelCorp;
        };
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      } | null;
    };
  };
  applicationEventsAndMessages: {
    __typename?: "ApplicationEventsAndMessages";
    events: Array<{
      __typename?: "ApplicationEvent";
      id: string;
      transactionID: string;
      orgId: string;
      eventType: ApplicationEventType;
      applicationId: string;
      createdAt: any;
      data: any;
      createdBy: {
        __typename?: "UserMetaInfoWithName";
        id: string;
        userType: UserType;
        name?: string | null;
      };
    }>;
  };
  paymentDetailByPayments: Array<{
    __typename?: "PaymentDetail";
    paymentId: string;
    amount: number;
    amountRefunded: number;
    amountDetail?: any | null;
    taxAmountDetail?: any | null;
    paymentMethods?: Array<PaymentMethod> | null;
    isRefundablePaymentMethod: boolean;
    invoice: {
      __typename?: "InvoiceWithRefundableAmount";
      items: Array<{
        __typename?: "InvoiceItemWithRefundableAmount";
        type: InvoiceItemType;
        amount: number;
        taxRate: TaxRateLiterals;
        description: string;
        refundableAmount: number;
      }>;
    };
    adjustmentRequiredDetail?: {
      __typename?: "AdjustmentRequiredDetail";
      exceeding?: number | null;
      deficiency?: number | null;
    } | null;
    payeasyDetail?: Array<{
      __typename?: "PayeasyDetail";
      invoiceNo: string;
      billDate: string;
      skNo: string;
      customerNum: string;
      confirmationNum: string;
      paidAmount: number;
      expiredAt?: number | null;
      isPaid: boolean;
      isExpiredWithNoPayment: boolean;
    }> | null;
  }>;
};

export type GetNewInvoiceCreationDataQueryVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
}>;

export type GetNewInvoiceCreationDataQuery = {
  __typename?: "Query";
  applicationDetailData: {
    __typename?: "ApplicationDetailData";
    application: { __typename?: "Application"; id: string; jsonDocument: any };
    procedure: {
      __typename?: "Procedure";
      id: string;
      published?: {
        __typename?: "PublishedDetail";
        applicantSchemaKeys: {
          __typename?: "ApplicantSchemaKeys";
          applicantSection: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantType: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateSearch: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPostalCode: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantAddress: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantBirthDate: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantTradeNameKana: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantCorporateNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantRepresentativeName: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantPhoneNumber: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantEmail: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
          applicantContactPersonal: {
            __typename?: "SchemaKey";
            formSchemaJsonPath: string;
            id: string;
          };
        };
      } | null;
    };
  };
  qualifiedInvoiceIssueRequest?: {
    __typename?: "QualifiedInvoiceIssueRequest";
    id: string;
    applicationId: string;
    withdrewAt?: any | null;
    availableIssuedQualifiedInvoice?: {
      __typename?: "QualifiedInvoiceIssueRequestIssuedQualifiedInvoice";
      id: string;
      issuedAt: any;
    } | null;
    revokedQualifiedInvoices: Array<{
      __typename?: "QualifiedInvoiceIssueRequestIssuedQualifiedInvoice";
      id: string;
      issuedAt: any;
    }>;
  } | null;
  qualifiedInvoiceDetailPayment?: {
    __typename?: "QualifiedInvoiceDetailPayment";
    amountDetail: any;
    taxAmountDetail: any;
    amount: number;
    items: Array<{
      __typename?: "QualifiedInvoiceDetailPaymentItem";
      amount: number;
      taxRate: TaxRateLiterals;
      description: string;
    }>;
  } | null;
};

export type RevertStatusMutationVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
  revertStatusCommand: RevertStatusCommand;
}>;

export type RevertStatusMutation = {
  __typename?: "Mutation";
  revertStatus:
    | {
        __typename: "IsOutdatedAppVersion";
        error: {
          __typename: "DomainError";
          message: string;
          code: DomainErrorCode;
          path: string;
        };
      }
    | {
        __typename: "ProcedureAplsReachedQuota";
        error: {
          __typename: "DomainError";
          message: string;
          code: DomainErrorCode;
          path: string;
        };
      }
    | { __typename: "RevertStatusResult"; ok: boolean };
};

export type RevokeQualifiedInvoiceMutationVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
}>;

export type RevokeQualifiedInvoiceMutation = {
  __typename?: "Mutation";
  revokeQualifiedInvoice: boolean;
};

export type TenantDataCountQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TenantDataCountQuery = {
  __typename?: "Query";
  publishingProcedureCount: number;
  applicationCountByOrgId: number;
  publishingSurveyCount: number;
  surveyAnswerCountByOrgId: number;
};

export type UnarchiveProcedureMutationVariables = Exact<{
  procedureId: Scalars["String"]["input"];
  previousUpdatedAtUnixTime: Scalars["Float"]["input"];
}>;

export type UnarchiveProcedureMutation = {
  __typename?: "Mutation";
  unarchiveProcedure: { __typename?: "UnarchiveProcedureResult"; ok: boolean };
};

export type UpdateTenantProcessResultMutationVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
  document: Scalars["Map"]["input"];
}>;

export type UpdateTenantProcessResultMutation = {
  __typename?: "Mutation";
  updateTenantProcessResult: boolean;
};

export type WithdrawQualifiedInvoiceIssueRequestMutationVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
}>;

export type WithdrawQualifiedInvoiceIssueRequestMutation = {
  __typename?: "Mutation";
  withdrawQualifiedInvoiceIssueRequest: boolean;
};

export const ApplicationEntityFragmentDoc = gql`
  fragment ApplicationEntity on Application {
    id
    name
    orgId
    procedureId
    procedureVersion
    status
    signature {
      certificateType
      contentStorageUrl
      signature
      hashAlgOid
      expectedHash
      signatureArrivedAt
      certCheckResult {
        verifyTicket
        isPending
        isValid
        uid
        surrogate
        asof
        notBefore
        notAfter
        issuerDn
        signatureId
      }
      jpkiSubjectAltName {
        commonName
        address
        gender
        dateOfBirth
        substituteCharacterOfCommonName
        substituteCharacterOfAddress
      }
      signedDataVersion
    }
    userIdExists
    jsonDocument
    files {
      refKey
      name
      type
      size
      tags
      url
    }
    myNumbers {
      myNumberId
      refKey
      last4Digit
    }
    modifiedAt
    applicantContent {
      jsonDocument
      files {
        refKey
        name
        type
        size
        tags
        url
      }
      myNumbers {
        myNumberId
        refKey
        last4Digit
      }
      modifiedAt
    }
    issueFiles {
      name
      type
      isDeleted
      isDownloaded
      url
    }
    tenantProcessResult
    paymentsV2 {
      amountCharged
      amountRefunded
      isCancelled
      invoice {
        items {
          type
          amount
          taxRate
          description
        }
      }
      acceptedPaymentMethods
      paymentId
      status
      amount
      amountDetail
      taxAmount
      taxAmountDetail
    }
    createdAt
    updatedAt
    createdAtUnixSecond
    updatedAtUnixSecond
    version
  }
`;
export const ApplicationEventEntityFragmentDoc = gql`
  fragment ApplicationEventEntity on ApplicationEvent {
    id
    transactionID
    orgId
    eventType
    applicationId
    createdAt
    data
    createdBy {
      id
      userType
      name
    }
  }
`;
export const ApplicationHistoryEntityFragmentDoc = gql`
  fragment ApplicationHistoryEntity on ApplicationHistory {
    id
    orgId
    applicationId
    modificationType
    jsonDocument
    files {
      refKey
      name
      type
      size
      tags
      url
    }
    myNumbers {
      myNumberId
      refKey
      last4Digit
    }
    signature {
      certificateType
      contentStorageUrl
      signature
      hashAlgOid
      expectedHash
      signatureArrivedAt
      certCheckResult {
        verifyTicket
        isPending
        isValid
        uid
        surrogate
        asof
        notBefore
        notAfter
        issuerDn
        signatureId
      }
      jpkiSubjectAltName {
        commonName
        address
        gender
        dateOfBirth
        substituteCharacterOfCommonName
        substituteCharacterOfAddress
      }
      signedDataVersion
    }
    internalCommentId
    modifiedAt
    modifiedBy {
      id
      userType
      name
    }
  }
`;
export const ApplicationMessageEntityFragmentDoc = gql`
  fragment ApplicationMessageEntity on Message {
    id
    applicationId
    operationType
    content
    createdAt
    createdBy
  }
`;
export const InternalCommentEntityFragmentDoc = gql`
  fragment InternalCommentEntity on InternalComment {
    id
    applicationId
    content
    operationType
    content
    createdAt
    createdBy
  }
`;
export const KintoneExportSettingEntityFragmentDoc = gql`
  fragment KintoneExportSettingEntity on KintoneExportSetting {
    id
    tenantId
    name
    description
    disabled
    formResourceId
    kintoneAppId
    kintoneSubdomain
    elementFieldMappings {
      formElementId
      kintoneFieldCode
    }
    metadataFieldMapping {
      submissionIdFieldCode
      submittedAtFieldCode
      submissionStatusFieldCode
      procedureNameFieldCode
    }
    createdAtUnixSecond
    updatedAtUnixSecond
  }
`;
export const KintoneExportedRecordEntityFragmentDoc = gql`
  fragment KintoneExportedRecordEntity on KintoneExportedRecord {
    id
    tenantId
    exportSettingId
    smartApplySubmissionId
    kintoneAppId
    kintoneRecordId
    kintoneRecordRevision
    createdAtUnixSecond
  }
`;
export const KintoneExportReportEntityFragmentDoc = gql`
  fragment KintoneExportReportEntity on KintoneExportReport {
    id
    tenantId
    exportSettingId
    grafferTraceId
    details {
      smartApplySubmissionId
      kintoneRecordId
      kintoneRecordRevision
      aplStatusUpdate {
        before
        after
      }
      errorMessage
      existingRecord {
        kintoneRecordId
        exportedRecordId
      }
      skippedByAplStatus
    }
    errorMessage
    submissionFilter {
      tenantId
      formResourceId
      fromUnixSecond
      toUnixSecond
    }
    startedAtUnixSecond
    createdAtUnixSecond
  }
`;
export const KintoneExportRequestEntityFragmentDoc = gql`
  fragment KintoneExportRequestEntity on KintoneExportRequest {
    id
    tenantId
    exportSettingId
    status
    errorDetail
    term {
      fromUnixMilli
      toUnixMilli
    }
    specifiedSubmissionIds
    createdReportId
    createdAtUnixSecond
    updatedAtUnixSecond
  }
`;
export const KintoneExportErrorDetailEntityFragmentDoc = gql`
  fragment KintoneExportErrorDetailEntity on KintoneExportErrorDetail {
    id
    smartApplySubmissionId
    settingId
    reportId
    errors
  }
`;
export const ApplicantSchemaKeysEntityFragmentDoc = gql`
  fragment ApplicantSchemaKeysEntity on ApplicantSchemaKeys {
    applicantSection {
      formSchemaJsonPath
      id
    }
    applicantType {
      formSchemaJsonPath
      id
    }
    applicantCorporateSearch {
      formSchemaJsonPath
      id
    }
    applicantName {
      formSchemaJsonPath
      id
    }
    applicantNameKana {
      formSchemaJsonPath
      id
    }
    applicantPostalCode {
      formSchemaJsonPath
      id
    }
    applicantAddress {
      formSchemaJsonPath
      id
    }
    applicantBirthDate {
      formSchemaJsonPath
      id
    }
    applicantTradeName {
      formSchemaJsonPath
      id
    }
    applicantTradeNameKana {
      formSchemaJsonPath
      id
    }
    applicantCorporateNumber {
      formSchemaJsonPath
      id
    }
    applicantRepresentativeName {
      formSchemaJsonPath
      id
    }
    applicantPhoneNumber {
      formSchemaJsonPath
      id
    }
    applicantEmail {
      formSchemaJsonPath
      id
    }
    applicantContactPersonal {
      formSchemaJsonPath
      id
    }
  }
`;
export const ProcedureEntityFragmentDoc = gql`
  fragment ProcedureEntity on Procedure {
    id
    version
    orgId
    summary
    detailURL
    descriptionMarkdown
    name
    groupIds
    publishStatus
    publishSetting {
      startAcceptAt
      endAcceptAt
      publishAt
      unPublishAt
      isPausingAccept
    }
    version
    isGrafferManaged
    isLinkTopPage
    customTag
    draft {
      template {
        formSchema
        pdfOutputSetting {
          pdfOutputBaseFile
          pdfOutputBaseFileName
          pdfOutputBaseFileURL
          metaInfoFormSchema
        }
      }
      acceptAnyFile
      paymentSetting {
        items {
          formulaId
          taxRate
          description
        }
      }
      requireAuthLevel {
        individual
        corporation
      }
      applicantSchemaKeys {
        ...ApplicantSchemaKeysEntity
      }
    }
    published {
      template {
        formSchema
        pdfOutputSetting {
          pdfOutputBaseFile
          pdfOutputBaseFileName
          pdfOutputBaseFileURL
          metaInfoFormSchema
        }
        tenantProcessResultSetting {
          inputElements
        }
      }
      acceptAnyFile
      paymentSetting {
        items {
          formulaId
          taxRate
          description
        }
      }
      requireAuthLevel {
        individual
        corporation
      }
      applicantSchemaKeys {
        ...ApplicantSchemaKeysEntity
      }
    }
    isExcludeFromSearch
    isSkipArrivalMail
    updatedAt
  }
  ${ApplicantSchemaKeysEntityFragmentDoc}
`;
export const AdjustPaymentExceedingOrDeficiencyDocument = gql`
  mutation AdjustPaymentExceedingOrDeficiency(
    $applicationId: ID!
    $version: Int!
    $paymentIndex: Int!
  ) {
    adjustPaymentExceedingOrDeficiency(
      applicationId: $applicationId
      version: $version
      paymentIndex: $paymentIndex
    )
  }
`;
export const ArchiveProcedureDocument = gql`
  mutation ArchiveProcedure(
    $procedureId: String!
    $previousUpdatedAtUnixTime: Float!
  ) {
    archiveProcedure(
      procedureId: $procedureId
      previousUpdatedAtUnixTime: $previousUpdatedAtUnixTime
    ) {
      ok
    }
  }
`;
export const RemoveSurveyAnswerDocument = gql`
  mutation removeSurveyAnswer($surveyId: ID!) {
    removeSurveyAnswers(surveyId: $surveyId) {
      ok
    }
  }
`;
export const ApplicationDocument = gql`
  query application($id: String!) {
    application(applicationId: $id) {
      ...ApplicationEntity
    }
  }
  ${ApplicationEntityFragmentDoc}
`;
export const ApplicationAndProcedureDocument = gql`
  query applicationAndProcedure($id: ID!) {
    applicationDetailData(applicationId: $id) {
      application {
        ...ApplicationEntity
      }
      procedure {
        ...ProcedureEntity
      }
    }
  }
  ${ApplicationEntityFragmentDoc}
  ${ProcedureEntityFragmentDoc}
`;
export const ApplicationAllDetailDataDocument = gql`
  query applicationAllDetailData($id: String!, $typedId: ID!) {
    applicationDetailData(applicationId: $typedId) {
      procedure {
        ...ProcedureEntity
      }
    }
    applicationHistories(applicationId: $id) {
      applicationHistory {
        ...ApplicationHistoryEntity
      }
      internalComment {
        ...InternalCommentEntity
      }
    }
    applicationEventsAndMessages(applicationId: $id) {
      events {
        ...ApplicationEventEntity
      }
      messages {
        ...ApplicationMessageEntity
      }
    }
    internalCommentsAndUsers(applicationId: $id) {
      id
      content
      operationType
      content
      createdAt
      createdBy {
        name
      }
    }
    paymentSummary(applicationId: $typedId) {
      amount
      amountRefunded
      invoice {
        items {
          amount
          taxRate
          description
          operationType
          fixedAt
        }
      }
      amountDetail
      taxAmountDetail
      adjustmentRequiredDetail {
        exceeding
        deficiency
      }
      operations {
        paymentTransactionType
        applicationId
        paymentId
        amount
        items {
          type
          amount
          taxRate
          description
        }
        createdAt
      }
    }
    paymentDetailByPayments(applicationId: $typedId) {
      paymentId
      amount
      amountRefunded
      invoice {
        items {
          type
          amount
          taxRate
          description
          refundableAmount
        }
      }
      amountDetail
      taxAmountDetail
      adjustmentRequiredDetail {
        exceeding
        deficiency
      }
      payeasyDetail {
        invoiceNo
        billDate
        skNo
        customerNum
        confirmationNum
        paidAmount
        expiredAt
        isPaid
        isExpiredWithNoPayment
      }
      paymentMethods
      isRefundablePaymentMethod
    }
  }
  ${ProcedureEntityFragmentDoc}
  ${ApplicationHistoryEntityFragmentDoc}
  ${InternalCommentEntityFragmentDoc}
  ${ApplicationEventEntityFragmentDoc}
  ${ApplicationMessageEntityFragmentDoc}
`;
export const GetApplicationsByProcedureDocument = gql`
  query getApplicationsByProcedure(
    $procedureId: String!
    $page: Int!
    $limit: Int!
    $from: String
    $to: String
    $status: [Status!]
  ) {
    applicationsByProcedure(
      procedureId: $procedureId
      page: $page
      limit: $limit
      from: $from
      to: $to
      status: $status
    ) {
      applications {
        ...ApplicationEntity
      }
      procedure {
        ...ProcedureEntity
      }
      totalCount
    }
  }
  ${ApplicationEntityFragmentDoc}
  ${ProcedureEntityFragmentDoc}
`;
export const ApplicationEventsDocument = gql`
  query applicationEvents($id: String!) {
    applicationEventsAndMessages(applicationId: $id) {
      events {
        ...ApplicationEventEntity
      }
    }
  }
  ${ApplicationEventEntityFragmentDoc}
`;
export const ApplicationEventsAndMessagesDocument = gql`
  query applicationEventsAndMessages($id: String!) {
    applicationEventsAndMessages(applicationId: $id) {
      events {
        ...ApplicationEventEntity
      }
      messages {
        ...ApplicationMessageEntity
      }
    }
  }
  ${ApplicationEventEntityFragmentDoc}
  ${ApplicationMessageEntityFragmentDoc}
`;
export const ApplicationHistoriesDocument = gql`
  query applicationHistories($id: String!) {
    applicationHistories(applicationId: $id) {
      applicationHistory {
        ...ApplicationHistoryEntity
      }
      internalComment {
        ...InternalCommentEntity
      }
    }
  }
  ${ApplicationHistoryEntityFragmentDoc}
  ${InternalCommentEntityFragmentDoc}
`;
export const ApplicationTaskAndUserDocument = gql`
  query applicationTaskAndUser($id: String!) {
    applicationTaskAndUser(taskId: $id) {
      id
      orgId
      taskType
      taskDetails {
        applicationId
        taskStatus
        errCode
      }
      createdAt
      updatedAt
      user {
        name
      }
    }
  }
`;
export const GetApplicationsWithApplicantSchemaKeysDocument = gql`
  query getApplicationsWithApplicantSchemaKeys(
    $page: Int!
    $limit: Int!
    $sort: ApplicationsWithApplicationSchemaKeysSort!
    $from: String
    $to: String
    $status: [Status!]
  ) {
    applicationsWithApplicantSchemaKeys(
      page: $page
      limit: $limit
      sort: $sort
      from: $from
      to: $to
      status: $status
    ) {
      applications {
        application {
          ...ApplicationEntity
        }
        applicantSchemaKeys {
          ...ApplicantSchemaKeysEntity
        }
      }
      totalCount
    }
  }
  ${ApplicationEntityFragmentDoc}
  ${ApplicantSchemaKeysEntityFragmentDoc}
`;
export const GetAssignedApplicationsDocument = gql`
  query getAssignedApplications(
    $page: Int!
    $limit: Int!
    $sort: ApplicationsWithApplicationSchemaKeysSort!
    $from: String
    $to: String
    $procedureId: String
    $status: [Status!]
  ) {
    assignedApplications(
      page: $page
      limit: $limit
      sort: $sort
      from: $from
      to: $to
      procedureId: $procedureId
      status: $status
    ) {
      applications {
        application {
          ...ApplicationEntity
        }
        applicantSchemaKeys {
          ...ApplicantSchemaKeysEntity
        }
      }
      totalCount
    }
  }
  ${ApplicationEntityFragmentDoc}
  ${ApplicantSchemaKeysEntityFragmentDoc}
`;
export const InternalCommentsAndUsersDocument = gql`
  query internalCommentsAndUsers($id: String!) {
    internalCommentsAndUsers(applicationId: $id) {
      id
      content
      operationType
      content
      createdAt
      createdBy {
        name
      }
    }
  }
`;
export const GetLatestQualifiedInvoiceDocument = gql`
  query getLatestQualifiedInvoice($applicationId: ID!) {
    latestQualifiedInvoice(applicationId: $applicationId) {
      id
      applicationId
      detail {
        buyerName
        qualifiedInvoiceBusinessIssuer {
          name
          registrationNumber
        }
        transactionDate {
          year
          month
          day
        }
        payment {
          items {
            amount
            taxRate
            description
          }
          amount
          amountDetail
          taxAmountDetail
        }
      }
    }
  }
`;
export const MessagesDocument = gql`
  query messages($id: String!) {
    messages(applicationId: $id) {
      id
      content
      operationType
      content
      createdAt
      createdBy
    }
  }
`;
export const PaymentSummaryDocument = gql`
  query paymentSummary($id: ID!) {
    paymentSummary(applicationId: $id) {
      amount
      amountRefunded
      invoice {
        items {
          type
          amount
          taxRate
          description
          operationType
          fixedAt
        }
      }
      amountDetail
      taxAmountDetail
      adjustmentRequiredDetail {
        deficiency
        exceeding
      }
      operations {
        paymentTransactionType
        applicationId
        paymentId
        amount
        items {
          type
          amount
          taxRate
          description
        }
        createdAt
      }
    }
  }
`;
export const PaymentDetailsDocument = gql`
  query paymentDetails($id: ID!) {
    paymentSummary(applicationId: $id) {
      amount
      amountRefunded
      invoice {
        items {
          amount
          taxRate
          description
          operationType
          fixedAt
        }
      }
      amountDetail
      taxAmountDetail
      adjustmentRequiredDetail {
        exceeding
        deficiency
      }
      operations {
        paymentTransactionType
        applicationId
        paymentId
        amount
        items {
          type
          amount
          taxRate
          description
        }
        createdAt
      }
    }
    paymentDetailByPayments(applicationId: $id) {
      paymentId
      amount
      amountRefunded
      invoice {
        items {
          type
          amount
          taxRate
          description
          refundableAmount
        }
      }
      amountDetail
      taxAmountDetail
      adjustmentRequiredDetail {
        exceeding
        deficiency
      }
      payeasyDetail {
        invoiceNo
        billDate
        skNo
        customerNum
        confirmationNum
        paidAmount
        expiredAt
        isPaid
        isExpiredWithNoPayment
      }
      paymentMethods
      isRefundablePaymentMethod
    }
  }
`;
export const ProceduresWithCustomPathDocument = gql`
  query proceduresWithCustomPath($path: String!, $orgId: String!) {
    proceduresWithCustomPath(customPath: $path, orgId: $orgId) {
      procUsingCustomPath {
        ...ProcedureEntity
      }
      procHasReservedCustomPath {
        ...ProcedureEntity
      }
    }
  }
  ${ProcedureEntityFragmentDoc}
`;
export const CurrentCustomPathsDocument = gql`
  query currentCustomPaths($orgId: String!, $procedureId: String!) {
    currentCustomPaths(orgId: $orgId, procedureId: $procedureId) {
      currentCustomPath {
        orgId
        procedureId
        customPath
        startUnixtime
      }
      nextCustomPath {
        orgId
        procedureId
        customPath
        startUnixtime
      }
    }
  }
`;
export const AssignedApplicationsProceduresDocument = gql`
  query assignedApplicationsProcedures($name: String) {
    assignedApplicationsProcedures(name: $name) {
      procedures {
        id
        name
      }
    }
  }
`;
export const GetQualifiedInvoiceDocument = gql`
  query getQualifiedInvoice($id: ID!, $applicationId: ID!) {
    qualifiedInvoice(id: $id, applicationId: $applicationId) {
      id
      applicationId
      detail {
        buyerName
        qualifiedInvoiceBusinessIssuer {
          name
          registrationNumber
        }
        transactionDate {
          year
          month
          day
        }
        payment {
          items {
            amount
            taxRate
            description
          }
          amount
          amountDetail
          taxAmountDetail
        }
      }
    }
  }
`;
export const GetQualifiedInvoiceDetailPaymentDocument = gql`
  query getQualifiedInvoiceDetailPayment($applicationId: ID!) {
    qualifiedInvoiceDetailPayment(applicationId: $applicationId) {
      amountDetail
      taxAmountDetail
      amount
      items {
        amount
        taxRate
        description
      }
    }
  }
`;
export const GetQualifiedInvoiceIssueRequestDocument = gql`
  query getQualifiedInvoiceIssueRequest($applicationId: ID!) {
    qualifiedInvoiceIssueControlStatus(applicationId: $applicationId) {
      isIssuableProcedure
      hasTaxablePayment
      isPaymentCompleted
      isIssuableApplicationStatus
    }
    qualifiedInvoiceIssueRequest(applicationId: $applicationId) {
      id
      applicationId
      availableIssuedQualifiedInvoice {
        id
        issuedAt
      }
      revokedQualifiedInvoices {
        id
        issuedAt
      }
      withdrewAt
    }
  }
`;
export const GetUnhandledQualifiedInvoiceIssueRequestsDocument = gql`
  query getUnhandledQualifiedInvoiceIssueRequests($orgId: ID!) {
    unhandledQualifiedInvoiceIssueRequests(orgId: $orgId) {
      id
      applicationId
      applicationName
      createdAt
    }
  }
`;
export const IssueQualifiedInvoiceDocument = gql`
  mutation issueQualifiedInvoice($input: IssueQualifiedInvoiceInput!) {
    issueQualifiedInvoice(input: $input)
  }
`;
export const KintoneExportSettingsDocument = gql`
  query kintoneExportSettings(
    $tenantId: String!
    $groupIds: [String!]
    $page: KintoneExportResourcePage!
  ) {
    kintoneExportSettingsV2(
      filter: { tenantId: $tenantId, groupIds: $groupIds }
      page: $page
    ) {
      totalCount
      edges {
        node {
          id
          name
          formResourceId
          disabled
        }
      }
    }
  }
`;
export const KintoneExportSettingDocument = gql`
  query kintoneExportSetting($id: ID!) {
    kintoneExportSetting(id: $id) {
      ...KintoneExportSettingEntity
    }
  }
  ${KintoneExportSettingEntityFragmentDoc}
`;
export const KintoneExportedRecordsDocument = gql`
  query kintoneExportedRecords(
    $tenantId: String!
    $kintoneExportSettingId: ID!
    $page: KintoneExportResourcePage!
  ) {
    kintoneExportedRecordsV2(
      filter: {
        tenantId: $tenantId
        kintoneExportSettingId: $kintoneExportSettingId
      }
      page: $page
    ) {
      totalCount
      edges {
        node {
          ...KintoneExportedRecordEntity
        }
      }
    }
  }
  ${KintoneExportedRecordEntityFragmentDoc}
`;
export const KintoneExportReportsDocument = gql`
  query kintoneExportReports(
    $tenantId: String!
    $kintoneExportSettingId: ID!
    $page: KintoneExportResourcePage!
  ) {
    kintoneExportReportsV2(
      filter: {
        tenantId: $tenantId
        kintoneExportSettingId: $kintoneExportSettingId
      }
      page: $page
    ) {
      totalCount
      edges {
        node {
          id
          startedAtUnixSecond
          createdAtUnixSecond
        }
      }
    }
  }
`;
export const KintoneFieldsBySettingIdDocument = gql`
  query kintoneFieldsBySettingId($settingId: ID!) {
    kintoneFields(kintoneExportSettingId: $settingId) {
      properties
      revision
    }
  }
`;
export const KintoneExportReportDocument = gql`
  query kintoneExportReport($id: ID!, $kintoneExportSettingId: ID!) {
    kintoneExportReport(id: $id) {
      ...KintoneExportReportEntity
    }
    kintoneExportSetting(id: $kintoneExportSettingId) {
      ...KintoneExportSettingEntity
    }
  }
  ${KintoneExportReportEntityFragmentDoc}
  ${KintoneExportSettingEntityFragmentDoc}
`;
export const KintoneExportRequestDocument = gql`
  query kintoneExportRequest($id: ID!) {
    kintoneExportRequest(id: $id) {
      ...KintoneExportRequestEntity
    }
  }
  ${KintoneExportRequestEntityFragmentDoc}
`;
export const KintoneExportErrorDetailsDocument = gql`
  query kintoneExportErrorDetails($reportId: ID!) {
    kintoneExportErrorDetails(reportId: $reportId) {
      totalCount
      edges {
        node {
          ...KintoneExportErrorDetailEntity
        }
      }
    }
  }
  ${KintoneExportErrorDetailEntityFragmentDoc}
`;
export const CreateKintoneExportSettingDocument = gql`
  mutation createKintoneExportSetting(
    $input: CreateKintoneExportSettingInput!
  ) {
    createKintoneExportSetting(input: $input) {
      ...KintoneExportSettingEntity
    }
  }
  ${KintoneExportSettingEntityFragmentDoc}
`;
export const UpdateKintoneExportSettingDocument = gql`
  mutation updateKintoneExportSetting(
    $input: UpdateKintoneExportSettingInput!
  ) {
    updateKintoneExportSetting(input: $input) {
      ...KintoneExportSettingEntity
    }
  }
  ${KintoneExportSettingEntityFragmentDoc}
`;
export const DeleteKintoneExportedRecordDocument = gql`
  mutation deleteKintoneExportedRecord($id: ID!) {
    deleteKintoneExportedRecord(id: $id) {
      msg
    }
  }
`;
export const RequestKintoneExportDocument = gql`
  mutation requestKintoneExport($input: RequestKintoneExportInput!) {
    requestKintoneExport(input: $input) {
      ...KintoneExportRequestEntity
    }
  }
  ${KintoneExportRequestEntityFragmentDoc}
`;
export const ApplicationPaymentDetailDataDocument = gql`
  query applicationPaymentDetailData($id: String!, $typedId: ID!) {
    applicationDetailData(applicationId: $typedId) {
      procedure {
        ...ProcedureEntity
      }
    }
    applicationEventsAndMessages(applicationId: $id) {
      events {
        ...ApplicationEventEntity
      }
    }
    paymentDetailByPayments(applicationId: $typedId) {
      paymentId
      amount
      amountRefunded
      invoice {
        items {
          type
          amount
          taxRate
          description
          refundableAmount
        }
      }
      amountDetail
      taxAmountDetail
      adjustmentRequiredDetail {
        exceeding
        deficiency
      }
      payeasyDetail {
        invoiceNo
        billDate
        skNo
        customerNum
        confirmationNum
        paidAmount
        expiredAt
        isPaid
        isExpiredWithNoPayment
      }
      paymentMethods
      isRefundablePaymentMethod
    }
  }
  ${ProcedureEntityFragmentDoc}
  ${ApplicationEventEntityFragmentDoc}
`;
export const GetNewInvoiceCreationDataDocument = gql`
  query getNewInvoiceCreationData($applicationId: ID!) {
    applicationDetailData(applicationId: $applicationId) {
      application {
        id
        jsonDocument
      }
      procedure {
        id
        published {
          applicantSchemaKeys {
            ...ApplicantSchemaKeysEntity
          }
        }
      }
    }
    qualifiedInvoiceIssueRequest(applicationId: $applicationId) {
      id
      applicationId
      availableIssuedQualifiedInvoice {
        id
        issuedAt
      }
      revokedQualifiedInvoices {
        id
        issuedAt
      }
      withdrewAt
    }
    qualifiedInvoiceDetailPayment(applicationId: $applicationId) {
      amountDetail
      taxAmountDetail
      amount
      items {
        amount
        taxRate
        description
      }
    }
  }
  ${ApplicantSchemaKeysEntityFragmentDoc}
`;
export const RevertStatusDocument = gql`
  mutation RevertStatus(
    $applicationId: ID!
    $revertStatusCommand: RevertStatusCommand!
  ) {
    revertStatus(
      applicationId: $applicationId
      revertStatusCommand: $revertStatusCommand
    ) {
      __typename
      ... on RevertStatusResult {
        ok
      }
      ... on IsOutdatedAppVersion {
        error {
          __typename
          message
          code
          path
        }
      }
      ... on ProcedureAplsReachedQuota {
        error {
          __typename
          message
          code
          path
        }
      }
    }
  }
`;
export const RevokeQualifiedInvoiceDocument = gql`
  mutation revokeQualifiedInvoice($applicationId: ID!) {
    revokeQualifiedInvoice(applicationId: $applicationId)
  }
`;
export const TenantDataCountDocument = gql`
  query tenantDataCount($id: ID!) {
    publishingProcedureCount(orgId: $id)
    applicationCountByOrgId(orgId: $id)
    publishingSurveyCount(orgId: $id)
    surveyAnswerCountByOrgId(orgId: $id)
  }
`;
export const UnarchiveProcedureDocument = gql`
  mutation UnarchiveProcedure(
    $procedureId: String!
    $previousUpdatedAtUnixTime: Float!
  ) {
    unarchiveProcedure(
      procedureId: $procedureId
      previousUpdatedAtUnixTime: $previousUpdatedAtUnixTime
    ) {
      ok
    }
  }
`;
export const UpdateTenantProcessResultDocument = gql`
  mutation UpdateTenantProcessResult($applicationId: ID!, $document: Map!) {
    updateTenantProcessResult(
      applicationId: $applicationId
      document: $document
    )
  }
`;
export const WithdrawQualifiedInvoiceIssueRequestDocument = gql`
  mutation withdrawQualifiedInvoiceIssueRequest($applicationId: ID!) {
    withdrawQualifiedInvoiceIssueRequest(applicationId: $applicationId)
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
  _variables,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    AdjustPaymentExceedingOrDeficiency(
      variables: AdjustPaymentExceedingOrDeficiencyMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdjustPaymentExceedingOrDeficiencyMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdjustPaymentExceedingOrDeficiencyMutation>({
            document: AdjustPaymentExceedingOrDeficiencyDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "AdjustPaymentExceedingOrDeficiency",
        "mutation",
        variables,
      );
    },
    ArchiveProcedure(
      variables: ArchiveProcedureMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ArchiveProcedureMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ArchiveProcedureMutation>({
            document: ArchiveProcedureDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ArchiveProcedure",
        "mutation",
        variables,
      );
    },
    removeSurveyAnswer(
      variables: RemoveSurveyAnswerMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RemoveSurveyAnswerMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveSurveyAnswerMutation>({
            document: RemoveSurveyAnswerDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeSurveyAnswer",
        "mutation",
        variables,
      );
    },
    application(
      variables: ApplicationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationQuery>({
            document: ApplicationDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "application",
        "query",
        variables,
      );
    },
    applicationAndProcedure(
      variables: ApplicationAndProcedureQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationAndProcedureQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationAndProcedureQuery>({
            document: ApplicationAndProcedureDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applicationAndProcedure",
        "query",
        variables,
      );
    },
    applicationAllDetailData(
      variables: ApplicationAllDetailDataQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationAllDetailDataQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationAllDetailDataQuery>({
            document: ApplicationAllDetailDataDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applicationAllDetailData",
        "query",
        variables,
      );
    },
    getApplicationsByProcedure(
      variables: GetApplicationsByProcedureQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetApplicationsByProcedureQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetApplicationsByProcedureQuery>({
            document: GetApplicationsByProcedureDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getApplicationsByProcedure",
        "query",
        variables,
      );
    },
    applicationEvents(
      variables: ApplicationEventsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationEventsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationEventsQuery>({
            document: ApplicationEventsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applicationEvents",
        "query",
        variables,
      );
    },
    applicationEventsAndMessages(
      variables: ApplicationEventsAndMessagesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationEventsAndMessagesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationEventsAndMessagesQuery>({
            document: ApplicationEventsAndMessagesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applicationEventsAndMessages",
        "query",
        variables,
      );
    },
    applicationHistories(
      variables: ApplicationHistoriesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationHistoriesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationHistoriesQuery>({
            document: ApplicationHistoriesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applicationHistories",
        "query",
        variables,
      );
    },
    applicationTaskAndUser(
      variables: ApplicationTaskAndUserQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationTaskAndUserQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationTaskAndUserQuery>({
            document: ApplicationTaskAndUserDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applicationTaskAndUser",
        "query",
        variables,
      );
    },
    getApplicationsWithApplicantSchemaKeys(
      variables: GetApplicationsWithApplicantSchemaKeysQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetApplicationsWithApplicantSchemaKeysQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetApplicationsWithApplicantSchemaKeysQuery>({
            document: GetApplicationsWithApplicantSchemaKeysDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getApplicationsWithApplicantSchemaKeys",
        "query",
        variables,
      );
    },
    getAssignedApplications(
      variables: GetAssignedApplicationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetAssignedApplicationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAssignedApplicationsQuery>({
            document: GetAssignedApplicationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getAssignedApplications",
        "query",
        variables,
      );
    },
    internalCommentsAndUsers(
      variables: InternalCommentsAndUsersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<InternalCommentsAndUsersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<InternalCommentsAndUsersQuery>({
            document: InternalCommentsAndUsersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "internalCommentsAndUsers",
        "query",
        variables,
      );
    },
    getLatestQualifiedInvoice(
      variables: GetLatestQualifiedInvoiceQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetLatestQualifiedInvoiceQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLatestQualifiedInvoiceQuery>({
            document: GetLatestQualifiedInvoiceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getLatestQualifiedInvoice",
        "query",
        variables,
      );
    },
    messages(
      variables: MessagesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<MessagesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<MessagesQuery>({
            document: MessagesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "messages",
        "query",
        variables,
      );
    },
    paymentSummary(
      variables: PaymentSummaryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<PaymentSummaryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PaymentSummaryQuery>({
            document: PaymentSummaryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "paymentSummary",
        "query",
        variables,
      );
    },
    paymentDetails(
      variables: PaymentDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<PaymentDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PaymentDetailsQuery>({
            document: PaymentDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "paymentDetails",
        "query",
        variables,
      );
    },
    proceduresWithCustomPath(
      variables: ProceduresWithCustomPathQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ProceduresWithCustomPathQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ProceduresWithCustomPathQuery>({
            document: ProceduresWithCustomPathDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "proceduresWithCustomPath",
        "query",
        variables,
      );
    },
    currentCustomPaths(
      variables: CurrentCustomPathsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CurrentCustomPathsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CurrentCustomPathsQuery>({
            document: CurrentCustomPathsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "currentCustomPaths",
        "query",
        variables,
      );
    },
    assignedApplicationsProcedures(
      variables?: AssignedApplicationsProceduresQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AssignedApplicationsProceduresQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AssignedApplicationsProceduresQuery>({
            document: AssignedApplicationsProceduresDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "assignedApplicationsProcedures",
        "query",
        variables,
      );
    },
    getQualifiedInvoice(
      variables: GetQualifiedInvoiceQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetQualifiedInvoiceQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetQualifiedInvoiceQuery>({
            document: GetQualifiedInvoiceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getQualifiedInvoice",
        "query",
        variables,
      );
    },
    getQualifiedInvoiceDetailPayment(
      variables: GetQualifiedInvoiceDetailPaymentQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetQualifiedInvoiceDetailPaymentQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetQualifiedInvoiceDetailPaymentQuery>({
            document: GetQualifiedInvoiceDetailPaymentDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getQualifiedInvoiceDetailPayment",
        "query",
        variables,
      );
    },
    getQualifiedInvoiceIssueRequest(
      variables: GetQualifiedInvoiceIssueRequestQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetQualifiedInvoiceIssueRequestQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetQualifiedInvoiceIssueRequestQuery>({
            document: GetQualifiedInvoiceIssueRequestDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getQualifiedInvoiceIssueRequest",
        "query",
        variables,
      );
    },
    getUnhandledQualifiedInvoiceIssueRequests(
      variables: GetUnhandledQualifiedInvoiceIssueRequestsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetUnhandledQualifiedInvoiceIssueRequestsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetUnhandledQualifiedInvoiceIssueRequestsQuery>({
            document: GetUnhandledQualifiedInvoiceIssueRequestsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getUnhandledQualifiedInvoiceIssueRequests",
        "query",
        variables,
      );
    },
    issueQualifiedInvoice(
      variables: IssueQualifiedInvoiceMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<IssueQualifiedInvoiceMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IssueQualifiedInvoiceMutation>({
            document: IssueQualifiedInvoiceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "issueQualifiedInvoice",
        "mutation",
        variables,
      );
    },
    kintoneExportSettings(
      variables: KintoneExportSettingsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneExportSettingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneExportSettingsQuery>({
            document: KintoneExportSettingsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneExportSettings",
        "query",
        variables,
      );
    },
    kintoneExportSetting(
      variables: KintoneExportSettingQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneExportSettingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneExportSettingQuery>({
            document: KintoneExportSettingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneExportSetting",
        "query",
        variables,
      );
    },
    kintoneExportedRecords(
      variables: KintoneExportedRecordsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneExportedRecordsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneExportedRecordsQuery>({
            document: KintoneExportedRecordsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneExportedRecords",
        "query",
        variables,
      );
    },
    kintoneExportReports(
      variables: KintoneExportReportsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneExportReportsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneExportReportsQuery>({
            document: KintoneExportReportsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneExportReports",
        "query",
        variables,
      );
    },
    kintoneFieldsBySettingId(
      variables: KintoneFieldsBySettingIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneFieldsBySettingIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneFieldsBySettingIdQuery>({
            document: KintoneFieldsBySettingIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneFieldsBySettingId",
        "query",
        variables,
      );
    },
    kintoneExportReport(
      variables: KintoneExportReportQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneExportReportQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneExportReportQuery>({
            document: KintoneExportReportDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneExportReport",
        "query",
        variables,
      );
    },
    kintoneExportRequest(
      variables: KintoneExportRequestQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneExportRequestQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneExportRequestQuery>({
            document: KintoneExportRequestDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneExportRequest",
        "query",
        variables,
      );
    },
    kintoneExportErrorDetails(
      variables: KintoneExportErrorDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<KintoneExportErrorDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<KintoneExportErrorDetailsQuery>({
            document: KintoneExportErrorDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "kintoneExportErrorDetails",
        "query",
        variables,
      );
    },
    createKintoneExportSetting(
      variables: CreateKintoneExportSettingMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateKintoneExportSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateKintoneExportSettingMutation>({
            document: CreateKintoneExportSettingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createKintoneExportSetting",
        "mutation",
        variables,
      );
    },
    updateKintoneExportSetting(
      variables: UpdateKintoneExportSettingMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateKintoneExportSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateKintoneExportSettingMutation>({
            document: UpdateKintoneExportSettingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateKintoneExportSetting",
        "mutation",
        variables,
      );
    },
    deleteKintoneExportedRecord(
      variables: DeleteKintoneExportedRecordMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<DeleteKintoneExportedRecordMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DeleteKintoneExportedRecordMutation>({
            document: DeleteKintoneExportedRecordDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "deleteKintoneExportedRecord",
        "mutation",
        variables,
      );
    },
    requestKintoneExport(
      variables: RequestKintoneExportMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RequestKintoneExportMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RequestKintoneExportMutation>({
            document: RequestKintoneExportDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "requestKintoneExport",
        "mutation",
        variables,
      );
    },
    applicationPaymentDetailData(
      variables: ApplicationPaymentDetailDataQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApplicationPaymentDetailDataQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApplicationPaymentDetailDataQuery>({
            document: ApplicationPaymentDetailDataDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applicationPaymentDetailData",
        "query",
        variables,
      );
    },
    getNewInvoiceCreationData(
      variables: GetNewInvoiceCreationDataQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetNewInvoiceCreationDataQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetNewInvoiceCreationDataQuery>({
            document: GetNewInvoiceCreationDataDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getNewInvoiceCreationData",
        "query",
        variables,
      );
    },
    RevertStatus(
      variables: RevertStatusMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RevertStatusMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RevertStatusMutation>({
            document: RevertStatusDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RevertStatus",
        "mutation",
        variables,
      );
    },
    revokeQualifiedInvoice(
      variables: RevokeQualifiedInvoiceMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RevokeQualifiedInvoiceMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RevokeQualifiedInvoiceMutation>({
            document: RevokeQualifiedInvoiceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "revokeQualifiedInvoice",
        "mutation",
        variables,
      );
    },
    tenantDataCount(
      variables: TenantDataCountQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<TenantDataCountQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TenantDataCountQuery>({
            document: TenantDataCountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "tenantDataCount",
        "query",
        variables,
      );
    },
    UnarchiveProcedure(
      variables: UnarchiveProcedureMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UnarchiveProcedureMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UnarchiveProcedureMutation>({
            document: UnarchiveProcedureDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UnarchiveProcedure",
        "mutation",
        variables,
      );
    },
    UpdateTenantProcessResult(
      variables: UpdateTenantProcessResultMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateTenantProcessResultMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateTenantProcessResultMutation>({
            document: UpdateTenantProcessResultDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateTenantProcessResult",
        "mutation",
        variables,
      );
    },
    withdrawQualifiedInvoiceIssueRequest(
      variables: WithdrawQualifiedInvoiceIssueRequestMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<WithdrawQualifiedInvoiceIssueRequestMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WithdrawQualifiedInvoiceIssueRequestMutation>({
            document: WithdrawQualifiedInvoiceIssueRequestDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "withdrawQualifiedInvoiceIssueRequest",
        "mutation",
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
